var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarnCertificate54Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 94,
    viewBox: "0 0 81 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 66.6553C14.9085 66.6553 15.459 66.1048 15.459 65.4258C15.459 64.7468 14.9085 64.1963 14.2295 64.1963C13.5505 64.1963 13 64.7468 13 65.4258C13 66.1048 13.5505 66.6553 14.2295 66.6553Z",
    fill: "#211242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 66.6553C18.3509 66.6553 18.9014 66.1048 18.9014 65.4258C18.9014 64.7468 18.3509 64.1963 17.6719 64.1963C16.9929 64.1963 16.4424 64.7468 16.4424 65.4258C16.4424 66.1048 16.9929 66.6553 17.6719 66.6553Z",
    fill: "#211242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 66.6563C21.7933 66.6563 22.3438 66.1058 22.3438 65.4268C22.3438 64.7477 21.7933 64.1973 21.1143 64.1973C20.4352 64.1973 19.8848 64.7477 19.8848 65.4268C19.8848 66.1058 20.4352 66.6563 21.1143 66.6563Z",
    fill: "#211242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 66.6563C25.2367 66.6563 25.7871 66.1058 25.7871 65.4268C25.7871 64.7477 25.2367 64.1973 24.5576 64.1973C23.8786 64.1973 23.3281 64.7477 23.3281 65.4268C23.3281 66.1058 23.8786 66.6563 24.5576 66.6563Z",
    fill: "#211242"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 66.6553C28.6791 66.6553 29.2295 66.1048 29.2295 65.4258C29.2295 64.7468 28.6791 64.1963 28 64.1963C27.321 64.1963 26.7705 64.7468 26.7705 65.4258C26.7705 66.1048 27.321 66.6553 28 66.6553Z",
    fill: "#211242"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 66.6553C32.1214 66.6553 32.6719 66.1048 32.6719 65.4258C32.6719 64.7468 32.1214 64.1963 31.4424 64.1963C30.7634 64.1963 30.2129 64.7468 30.2129 65.4258C30.2129 66.1048 30.7634 66.6553 31.4424 66.6553Z",
    fill: "#211242"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 66.6563C35.5638 66.6563 36.1143 66.1058 36.1143 65.4268C36.1143 64.7477 35.5638 64.1973 34.8848 64.1973C34.2057 64.1973 33.6553 64.7477 33.6553 65.4268C33.6553 66.1058 34.2057 66.6563 34.8848 66.6563Z",
    fill: "#211242"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 66.6563C39.0072 66.6563 39.5576 66.1058 39.5576 65.4268C39.5576 64.7477 39.0072 64.1973 38.3281 64.1973C37.6491 64.1973 37.0986 64.7477 37.0986 65.4268C37.0986 66.1058 37.6491 66.6563 38.3281 66.6563Z",
    fill: "#211242"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 66.6553C42.4496 66.6553 43 66.1048 43 65.4258C43 64.7468 42.4496 64.1963 41.7705 64.1963C41.0915 64.1963 40.541 64.7468 40.541 65.4258C40.541 66.1048 41.0915 66.6553 41.7705 66.6553Z",
    fill: "#211242"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 66.6553C45.8919 66.6553 46.4424 66.1048 46.4424 65.4258C46.4424 64.7468 45.8919 64.1963 45.2129 64.1963C44.5339 64.1963 43.9834 64.7468 43.9834 65.4258C43.9834 66.1048 44.5339 66.6553 45.2129 66.6553Z",
    fill: "#211242"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 66.6563C49.3343 66.6563 49.8848 66.1058 49.8848 65.4268C49.8848 64.7477 49.3343 64.1973 48.6553 64.1973C47.9763 64.1973 47.4258 64.7477 47.4258 65.4268C47.4258 66.1058 47.9763 66.6563 48.6553 66.6563Z",
    fill: "#211242"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 66.6563C52.7777 66.6563 53.3282 66.1058 53.3282 65.4268C53.3282 64.7477 52.7777 64.1973 52.0986 64.1973C51.4196 64.1973 50.8691 64.7477 50.8691 65.4268C50.8691 66.1058 51.4196 66.6563 52.0986 66.6563Z",
    fill: "#211242"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 66.6553C56.2201 66.6553 56.7705 66.1048 56.7705 65.4258C56.7705 64.7468 56.2201 64.1963 55.541 64.1963C54.862 64.1963 54.3115 64.7468 54.3115 65.4258C54.3115 66.1048 54.862 66.6553 55.541 66.6553Z",
    fill: "#211242"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 66.6553C59.6625 66.6553 60.2129 66.1048 60.2129 65.4258C60.2129 64.7468 59.6625 64.1963 58.9834 64.1963C58.3044 64.1963 57.7539 64.7468 57.7539 65.4258C57.7539 66.1048 58.3044 66.6553 58.9834 66.6553Z",
    fill: "#211242"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 66.6563C63.1048 66.6563 63.6553 66.1058 63.6553 65.4268C63.6553 64.7477 63.1048 64.1973 62.4258 64.1973C61.7468 64.1973 61.1963 64.7477 61.1963 65.4268C61.1963 66.1058 61.7468 66.6563 62.4258 66.6563Z",
    fill: "#211242"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 66.6563C66.5482 66.6563 67.0987 66.1058 67.0987 65.4268C67.0987 64.7477 66.5482 64.1973 65.8692 64.1973C65.1901 64.1973 64.6396 64.7477 64.6396 65.4268C64.6396 66.1058 65.1901 66.6563 65.8692 66.6563Z",
    fill: "#211242"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 63.2129C14.9085 63.2129 15.459 62.6625 15.459 61.9834C15.459 61.3044 14.9085 60.7539 14.2295 60.7539C13.5505 60.7539 13 61.3044 13 61.9834C13 62.6625 13.5505 63.2129 14.2295 63.2129Z",
    fill: "#211242"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 63.2129C18.3509 63.2129 18.9014 62.6625 18.9014 61.9834C18.9014 61.3044 18.3509 60.7539 17.6719 60.7539C16.9929 60.7539 16.4424 61.3044 16.4424 61.9834C16.4424 62.6625 16.9929 63.2129 17.6719 63.2129Z",
    fill: "#211242"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 63.2129C21.7933 63.2129 22.3438 62.6625 22.3438 61.9834C22.3438 61.3044 21.7933 60.7539 21.1143 60.7539C20.4352 60.7539 19.8848 61.3044 19.8848 61.9834C19.8848 62.6625 20.4352 63.2129 21.1143 63.2129Z",
    fill: "#211242"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 63.2129C25.2367 63.2129 25.7871 62.6625 25.7871 61.9834C25.7871 61.3044 25.2367 60.7539 24.5576 60.7539C23.8786 60.7539 23.3281 61.3044 23.3281 61.9834C23.3281 62.6625 23.8786 63.2129 24.5576 63.2129Z",
    fill: "#211242"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63.2129C28.6791 63.2129 29.2295 62.6625 29.2295 61.9834C29.2295 61.3044 28.6791 60.7539 28 60.7539C27.321 60.7539 26.7705 61.3044 26.7705 61.9834C26.7705 62.6625 27.321 63.2129 28 63.2129Z",
    fill: "#211242"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 63.2129C32.1214 63.2129 32.6719 62.6625 32.6719 61.9834C32.6719 61.3044 32.1214 60.7539 31.4424 60.7539C30.7634 60.7539 30.2129 61.3044 30.2129 61.9834C30.2129 62.6625 30.7634 63.2129 31.4424 63.2129Z",
    fill: "#211242"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 63.2129C35.5638 63.2129 36.1143 62.6625 36.1143 61.9834C36.1143 61.3044 35.5638 60.7539 34.8848 60.7539C34.2057 60.7539 33.6553 61.3044 33.6553 61.9834C33.6553 62.6625 34.2057 63.2129 34.8848 63.2129Z",
    fill: "#211242"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 63.2129C39.0072 63.2129 39.5576 62.6625 39.5576 61.9834C39.5576 61.3044 39.0072 60.7539 38.3281 60.7539C37.6491 60.7539 37.0986 61.3044 37.0986 61.9834C37.0986 62.6625 37.6491 63.2129 38.3281 63.2129Z",
    fill: "#211242"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 63.2129C42.4496 63.2129 43 62.6625 43 61.9834C43 61.3044 42.4496 60.7539 41.7705 60.7539C41.0915 60.7539 40.541 61.3044 40.541 61.9834C40.541 62.6625 41.0915 63.2129 41.7705 63.2129Z",
    fill: "#211242"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 63.2129C45.8919 63.2129 46.4424 62.6625 46.4424 61.9834C46.4424 61.3044 45.8919 60.7539 45.2129 60.7539C44.5339 60.7539 43.9834 61.3044 43.9834 61.9834C43.9834 62.6625 44.5339 63.2129 45.2129 63.2129Z",
    fill: "#211242"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 63.2129C49.3343 63.2129 49.8848 62.6625 49.8848 61.9834C49.8848 61.3044 49.3343 60.7539 48.6553 60.7539C47.9763 60.7539 47.4258 61.3044 47.4258 61.9834C47.4258 62.6625 47.9763 63.2129 48.6553 63.2129Z",
    fill: "#211242"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 63.2129C52.7777 63.2129 53.3282 62.6625 53.3282 61.9834C53.3282 61.3044 52.7777 60.7539 52.0986 60.7539C51.4196 60.7539 50.8691 61.3044 50.8691 61.9834C50.8691 62.6625 51.4196 63.2129 52.0986 63.2129Z",
    fill: "#211242"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 63.2129C56.2201 63.2129 56.7705 62.6625 56.7705 61.9834C56.7705 61.3044 56.2201 60.7539 55.541 60.7539C54.862 60.7539 54.3115 61.3044 54.3115 61.9834C54.3115 62.6625 54.862 63.2129 55.541 63.2129Z",
    fill: "#211242"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 63.2129C59.6625 63.2129 60.2129 62.6625 60.2129 61.9834C60.2129 61.3044 59.6625 60.7539 58.9834 60.7539C58.3044 60.7539 57.7539 61.3044 57.7539 61.9834C57.7539 62.6625 58.3044 63.2129 58.9834 63.2129Z",
    fill: "#211242"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 63.2129C63.1048 63.2129 63.6553 62.6625 63.6553 61.9834C63.6553 61.3044 63.1048 60.7539 62.4258 60.7539C61.7468 60.7539 61.1963 61.3044 61.1963 61.9834C61.1963 62.6625 61.7468 63.2129 62.4258 63.2129Z",
    fill: "#211242"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 63.2129C66.5482 63.2129 67.0987 62.6625 67.0987 61.9834C67.0987 61.3044 66.5482 60.7539 65.8692 60.7539C65.1901 60.7539 64.6396 61.3044 64.6396 61.9834C64.6396 62.6625 65.1901 63.2129 65.8692 63.2129Z",
    fill: "#211242"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 70C14.9085 70 15.459 69.4496 15.459 68.7705C15.459 68.0915 14.9085 67.541 14.2295 67.541C13.5505 67.541 13 68.0915 13 68.7705C13 69.4496 13.5505 70 14.2295 70Z",
    fill: "#211242"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 70C18.3509 70 18.9014 69.4496 18.9014 68.7705C18.9014 68.0915 18.3509 67.541 17.6719 67.541C16.9929 67.541 16.4424 68.0915 16.4424 68.7705C16.4424 69.4496 16.9929 70 17.6719 70Z",
    fill: "#211242"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 70C21.7933 70 22.3438 69.4496 22.3438 68.7705C22.3438 68.0915 21.7933 67.541 21.1143 67.541C20.4352 67.541 19.8848 68.0915 19.8848 68.7705C19.8848 69.4496 20.4352 70 21.1143 70Z",
    fill: "#211242"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 70C25.2367 70 25.7871 69.4496 25.7871 68.7705C25.7871 68.0915 25.2367 67.541 24.5576 67.541C23.8786 67.541 23.3281 68.0915 23.3281 68.7705C23.3281 69.4496 23.8786 70 24.5576 70Z",
    fill: "#211242"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28 70C28.6791 70 29.2295 69.4496 29.2295 68.7705C29.2295 68.0915 28.6791 67.541 28 67.541C27.321 67.541 26.7705 68.0915 26.7705 68.7705C26.7705 69.4496 27.321 70 28 70Z",
    fill: "#211242"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 70C32.1214 70 32.6719 69.4496 32.6719 68.7705C32.6719 68.0915 32.1214 67.541 31.4424 67.541C30.7634 67.541 30.2129 68.0915 30.2129 68.7705C30.2129 69.4496 30.7634 70 31.4424 70Z",
    fill: "#211242"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 70C35.5638 70 36.1143 69.4496 36.1143 68.7705C36.1143 68.0915 35.5638 67.541 34.8848 67.541C34.2057 67.541 33.6553 68.0915 33.6553 68.7705C33.6553 69.4496 34.2057 70 34.8848 70Z",
    fill: "#211242"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 70C39.0072 70 39.5576 69.4496 39.5576 68.7705C39.5576 68.0915 39.0072 67.541 38.3281 67.541C37.6491 67.541 37.0986 68.0915 37.0986 68.7705C37.0986 69.4496 37.6491 70 38.3281 70Z",
    fill: "#211242"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 70C42.4496 70 43 69.4496 43 68.7705C43 68.0915 42.4496 67.541 41.7705 67.541C41.0915 67.541 40.541 68.0915 40.541 68.7705C40.541 69.4496 41.0915 70 41.7705 70Z",
    fill: "#211242"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 70C45.8919 70 46.4424 69.4496 46.4424 68.7705C46.4424 68.0915 45.8919 67.541 45.2129 67.541C44.5339 67.541 43.9834 68.0915 43.9834 68.7705C43.9834 69.4496 44.5339 70 45.2129 70Z",
    fill: "#211242"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 70C49.3343 70 49.8848 69.4496 49.8848 68.7705C49.8848 68.0915 49.3343 67.541 48.6553 67.541C47.9763 67.541 47.4258 68.0915 47.4258 68.7705C47.4258 69.4496 47.9763 70 48.6553 70Z",
    fill: "#211242"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 70C52.7777 70 53.3282 69.4496 53.3282 68.7705C53.3282 68.0915 52.7777 67.541 52.0986 67.541C51.4196 67.541 50.8691 68.0915 50.8691 68.7705C50.8691 69.4496 51.4196 70 52.0986 70Z",
    fill: "#211242"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 70C56.2201 70 56.7705 69.4496 56.7705 68.7705C56.7705 68.0915 56.2201 67.541 55.541 67.541C54.862 67.541 54.3115 68.0915 54.3115 68.7705C54.3115 69.4496 54.862 70 55.541 70Z",
    fill: "#211242"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 70C59.6625 70 60.2129 69.4496 60.2129 68.7705C60.2129 68.0915 59.6625 67.541 58.9834 67.541C58.3044 67.541 57.7539 68.0915 57.7539 68.7705C57.7539 69.4496 58.3044 70 58.9834 70Z",
    fill: "#211242"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 70C63.1048 70 63.6553 69.4496 63.6553 68.7705C63.6553 68.0915 63.1048 67.541 62.4258 67.541C61.7468 67.541 61.1963 68.0915 61.1963 68.7705C61.1963 69.4496 61.7468 70 62.4258 70Z",
    fill: "#211242"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 70C66.5482 70 67.0987 69.4496 67.0987 68.7705C67.0987 68.0915 66.5482 67.541 65.8692 67.541C65.1901 67.541 64.6396 68.0915 64.6396 68.7705C64.6396 69.4496 65.1901 70 65.8692 70Z",
    fill: "#211242"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 59.7705C14.9085 59.7705 15.459 59.2201 15.459 58.541C15.459 57.862 14.9085 57.3115 14.2295 57.3115C13.5505 57.3115 13 57.862 13 58.541C13 59.2201 13.5505 59.7705 14.2295 59.7705Z",
    fill: "#211242"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 59.7705C18.3509 59.7705 18.9014 59.2201 18.9014 58.541C18.9014 57.862 18.3509 57.3115 17.6719 57.3115C16.9929 57.3115 16.4424 57.862 16.4424 58.541C16.4424 59.2201 16.9929 59.7705 17.6719 59.7705Z",
    fill: "#211242"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 59.7705C21.7933 59.7705 22.3438 59.2201 22.3438 58.541C22.3438 57.862 21.7933 57.3115 21.1143 57.3115C20.4352 57.3115 19.8848 57.862 19.8848 58.541C19.8848 59.2201 20.4352 59.7705 21.1143 59.7705Z",
    fill: "#211242"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 59.7705C25.2367 59.7705 25.7871 59.2201 25.7871 58.541C25.7871 57.862 25.2367 57.3115 24.5576 57.3115C23.8786 57.3115 23.3281 57.862 23.3281 58.541C23.3281 59.2201 23.8786 59.7705 24.5576 59.7705Z",
    fill: "#211242"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28 59.7705C28.6791 59.7705 29.2295 59.2201 29.2295 58.541C29.2295 57.862 28.6791 57.3115 28 57.3115C27.321 57.3115 26.7705 57.862 26.7705 58.541C26.7705 59.2201 27.321 59.7705 28 59.7705Z",
    fill: "#211242"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 59.7705C32.1214 59.7705 32.6719 59.2201 32.6719 58.541C32.6719 57.862 32.1214 57.3115 31.4424 57.3115C30.7634 57.3115 30.2129 57.862 30.2129 58.541C30.2129 59.2201 30.7634 59.7705 31.4424 59.7705Z",
    fill: "#211242"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 59.7705C35.5638 59.7705 36.1143 59.2201 36.1143 58.541C36.1143 57.862 35.5638 57.3115 34.8848 57.3115C34.2057 57.3115 33.6553 57.862 33.6553 58.541C33.6553 59.2201 34.2057 59.7705 34.8848 59.7705Z",
    fill: "#211242"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 59.7705C39.0072 59.7705 39.5576 59.2201 39.5576 58.541C39.5576 57.862 39.0072 57.3115 38.3281 57.3115C37.6491 57.3115 37.0986 57.862 37.0986 58.541C37.0986 59.2201 37.6491 59.7705 38.3281 59.7705Z",
    fill: "#211242"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 59.7705C42.4496 59.7705 43 59.2201 43 58.541C43 57.862 42.4496 57.3115 41.7705 57.3115C41.0915 57.3115 40.541 57.862 40.541 58.541C40.541 59.2201 41.0915 59.7705 41.7705 59.7705Z",
    fill: "#211242"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 59.7705C45.8919 59.7705 46.4424 59.2201 46.4424 58.541C46.4424 57.862 45.8919 57.3115 45.2129 57.3115C44.5339 57.3115 43.9834 57.862 43.9834 58.541C43.9834 59.2201 44.5339 59.7705 45.2129 59.7705Z",
    fill: "#211242"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 59.7705C49.3343 59.7705 49.8848 59.2201 49.8848 58.541C49.8848 57.862 49.3343 57.3115 48.6553 57.3115C47.9763 57.3115 47.4258 57.862 47.4258 58.541C47.4258 59.2201 47.9763 59.7705 48.6553 59.7705Z",
    fill: "#211242"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 59.7705C52.7777 59.7705 53.3282 59.2201 53.3282 58.541C53.3282 57.862 52.7777 57.3115 52.0986 57.3115C51.4196 57.3115 50.8691 57.862 50.8691 58.541C50.8691 59.2201 51.4196 59.7705 52.0986 59.7705Z",
    fill: "#211242"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 59.7705C56.2201 59.7705 56.7705 59.2201 56.7705 58.541C56.7705 57.862 56.2201 57.3115 55.541 57.3115C54.862 57.3115 54.3115 57.862 54.3115 58.541C54.3115 59.2201 54.862 59.7705 55.541 59.7705Z",
    fill: "#211242"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 59.7705C59.6625 59.7705 60.2129 59.2201 60.2129 58.541C60.2129 57.862 59.6625 57.3115 58.9834 57.3115C58.3044 57.3115 57.7539 57.862 57.7539 58.541C57.7539 59.2201 58.3044 59.7705 58.9834 59.7705Z",
    fill: "#211242"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 59.7705C63.1048 59.7705 63.6553 59.2201 63.6553 58.541C63.6553 57.862 63.1048 57.3115 62.4258 57.3115C61.7468 57.3115 61.1963 57.862 61.1963 58.541C61.1963 59.2201 61.7468 59.7705 62.4258 59.7705Z",
    fill: "#211242"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 59.7705C66.5482 59.7705 67.0987 59.2201 67.0987 58.541C67.0987 57.862 66.5482 57.3115 65.8692 57.3115C65.1901 57.3115 64.6396 57.862 64.6396 58.541C64.6396 59.2201 65.1901 59.7705 65.8692 59.7705Z",
    fill: "#211242"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 56.3282C14.9085 56.3282 15.459 55.7777 15.459 55.0986C15.459 54.4196 14.9085 53.8691 14.2295 53.8691C13.5505 53.8691 13 54.4196 13 55.0986C13 55.7777 13.5505 56.3282 14.2295 56.3282Z",
    fill: "#211242"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 56.3282C18.3509 56.3282 18.9014 55.7777 18.9014 55.0986C18.9014 54.4196 18.3509 53.8691 17.6719 53.8691C16.9929 53.8691 16.4424 54.4196 16.4424 55.0986C16.4424 55.7777 16.9929 56.3282 17.6719 56.3282Z",
    fill: "#211242"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 56.3282C21.7933 56.3282 22.3438 55.7777 22.3438 55.0986C22.3438 54.4196 21.7933 53.8691 21.1143 53.8691C20.4352 53.8691 19.8848 54.4196 19.8848 55.0986C19.8848 55.7777 20.4352 56.3282 21.1143 56.3282Z",
    fill: "#211242"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 56.3282C25.2367 56.3282 25.7871 55.7777 25.7871 55.0986C25.7871 54.4196 25.2367 53.8691 24.5576 53.8691C23.8786 53.8691 23.3281 54.4196 23.3281 55.0986C23.3281 55.7777 23.8786 56.3282 24.5576 56.3282Z",
    fill: "#211242"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M28 56.3282C28.6791 56.3282 29.2295 55.7777 29.2295 55.0986C29.2295 54.4196 28.6791 53.8691 28 53.8691C27.321 53.8691 26.7705 54.4196 26.7705 55.0986C26.7705 55.7777 27.321 56.3282 28 56.3282Z",
    fill: "#211242"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 56.3282C32.1214 56.3282 32.6719 55.7777 32.6719 55.0986C32.6719 54.4196 32.1214 53.8691 31.4424 53.8691C30.7634 53.8691 30.2129 54.4196 30.2129 55.0986C30.2129 55.7777 30.7634 56.3282 31.4424 56.3282Z",
    fill: "#211242"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 56.3282C35.5638 56.3282 36.1143 55.7777 36.1143 55.0986C36.1143 54.4196 35.5638 53.8691 34.8848 53.8691C34.2057 53.8691 33.6553 54.4196 33.6553 55.0986C33.6553 55.7777 34.2057 56.3282 34.8848 56.3282Z",
    fill: "#211242"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 56.3282C39.0072 56.3282 39.5576 55.7777 39.5576 55.0986C39.5576 54.4196 39.0072 53.8691 38.3281 53.8691C37.6491 53.8691 37.0986 54.4196 37.0986 55.0986C37.0986 55.7777 37.6491 56.3282 38.3281 56.3282Z",
    fill: "#211242"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 56.3282C42.4496 56.3282 43 55.7777 43 55.0986C43 54.4196 42.4496 53.8691 41.7705 53.8691C41.0915 53.8691 40.541 54.4196 40.541 55.0986C40.541 55.7777 41.0915 56.3282 41.7705 56.3282Z",
    fill: "#211242"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 56.3282C45.8919 56.3282 46.4424 55.7777 46.4424 55.0986C46.4424 54.4196 45.8919 53.8691 45.2129 53.8691C44.5339 53.8691 43.9834 54.4196 43.9834 55.0986C43.9834 55.7777 44.5339 56.3282 45.2129 56.3282Z",
    fill: "#211242"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 56.3282C49.3343 56.3282 49.8848 55.7777 49.8848 55.0986C49.8848 54.4196 49.3343 53.8691 48.6553 53.8691C47.9763 53.8691 47.4258 54.4196 47.4258 55.0986C47.4258 55.7777 47.9763 56.3282 48.6553 56.3282Z",
    fill: "#211242"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 56.3282C52.7777 56.3282 53.3282 55.7777 53.3282 55.0986C53.3282 54.4196 52.7777 53.8691 52.0986 53.8691C51.4196 53.8691 50.8691 54.4196 50.8691 55.0986C50.8691 55.7777 51.4196 56.3282 52.0986 56.3282Z",
    fill: "#211242"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 56.3282C56.2201 56.3282 56.7705 55.7777 56.7705 55.0986C56.7705 54.4196 56.2201 53.8691 55.541 53.8691C54.862 53.8691 54.3115 54.4196 54.3115 55.0986C54.3115 55.7777 54.862 56.3282 55.541 56.3282Z",
    fill: "#211242"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 56.3282C59.6625 56.3282 60.2129 55.7777 60.2129 55.0986C60.2129 54.4196 59.6625 53.8691 58.9834 53.8691C58.3044 53.8691 57.7539 54.4196 57.7539 55.0986C57.7539 55.7777 58.3044 56.3282 58.9834 56.3282Z",
    fill: "#211242"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 56.3282C63.1048 56.3282 63.6553 55.7777 63.6553 55.0986C63.6553 54.4196 63.1048 53.8691 62.4258 53.8691C61.7468 53.8691 61.1963 54.4196 61.1963 55.0986C61.1963 55.7777 61.7468 56.3282 62.4258 56.3282Z",
    fill: "#211242"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 56.3282C66.5482 56.3282 67.0987 55.7777 67.0987 55.0986C67.0987 54.4196 66.5482 53.8691 65.8692 53.8691C65.1901 53.8691 64.6396 54.4196 64.6396 55.0986C64.6396 55.7777 65.1901 56.3282 65.8692 56.3282Z",
    fill: "#211242"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 52.8848C14.9085 52.8848 15.459 52.3343 15.459 51.6553C15.459 50.9763 14.9085 50.4258 14.2295 50.4258C13.5505 50.4258 13 50.9763 13 51.6553C13 52.3343 13.5505 52.8848 14.2295 52.8848Z",
    fill: "#211242"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 52.8848C18.3509 52.8848 18.9014 52.3343 18.9014 51.6553C18.9014 50.9763 18.3509 50.4258 17.6719 50.4258C16.9929 50.4258 16.4424 50.9763 16.4424 51.6553C16.4424 52.3343 16.9929 52.8848 17.6719 52.8848Z",
    fill: "#211242"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 52.8848C21.7933 52.8848 22.3438 52.3343 22.3438 51.6553C22.3438 50.9763 21.7933 50.4258 21.1143 50.4258C20.4352 50.4258 19.8848 50.9763 19.8848 51.6553C19.8848 52.3343 20.4352 52.8848 21.1143 52.8848Z",
    fill: "#211242"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 52.8848C25.2367 52.8848 25.7871 52.3343 25.7871 51.6553C25.7871 50.9763 25.2367 50.4258 24.5576 50.4258C23.8786 50.4258 23.3281 50.9763 23.3281 51.6553C23.3281 52.3343 23.8786 52.8848 24.5576 52.8848Z",
    fill: "#211242"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52.8848C28.6791 52.8848 29.2295 52.3343 29.2295 51.6553C29.2295 50.9763 28.6791 50.4258 28 50.4258C27.321 50.4258 26.7705 50.9763 26.7705 51.6553C26.7705 52.3343 27.321 52.8848 28 52.8848Z",
    fill: "#211242"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 52.8848C32.1214 52.8848 32.6719 52.3343 32.6719 51.6553C32.6719 50.9763 32.1214 50.4258 31.4424 50.4258C30.7634 50.4258 30.2129 50.9763 30.2129 51.6553C30.2129 52.3343 30.7634 52.8848 31.4424 52.8848Z",
    fill: "#211242"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 52.8848C35.5638 52.8848 36.1143 52.3343 36.1143 51.6553C36.1143 50.9763 35.5638 50.4258 34.8848 50.4258C34.2057 50.4258 33.6553 50.9763 33.6553 51.6553C33.6553 52.3343 34.2057 52.8848 34.8848 52.8848Z",
    fill: "#211242"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 52.8848C39.0072 52.8848 39.5576 52.3343 39.5576 51.6553C39.5576 50.9763 39.0072 50.4258 38.3281 50.4258C37.6491 50.4258 37.0986 50.9763 37.0986 51.6553C37.0986 52.3343 37.6491 52.8848 38.3281 52.8848Z",
    fill: "#211242"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 52.8848C42.4496 52.8848 43 52.3343 43 51.6553C43 50.9763 42.4496 50.4258 41.7705 50.4258C41.0915 50.4258 40.541 50.9763 40.541 51.6553C40.541 52.3343 41.0915 52.8848 41.7705 52.8848Z",
    fill: "#211242"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 52.8848C45.8919 52.8848 46.4424 52.3343 46.4424 51.6553C46.4424 50.9763 45.8919 50.4258 45.2129 50.4258C44.5339 50.4258 43.9834 50.9763 43.9834 51.6553C43.9834 52.3343 44.5339 52.8848 45.2129 52.8848Z",
    fill: "#211242"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 52.8848C49.3343 52.8848 49.8848 52.3343 49.8848 51.6553C49.8848 50.9763 49.3343 50.4258 48.6553 50.4258C47.9763 50.4258 47.4258 50.9763 47.4258 51.6553C47.4258 52.3343 47.9763 52.8848 48.6553 52.8848Z",
    fill: "#211242"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 52.8848C52.7777 52.8848 53.3282 52.3343 53.3282 51.6553C53.3282 50.9763 52.7777 50.4258 52.0986 50.4258C51.4196 50.4258 50.8691 50.9763 50.8691 51.6553C50.8691 52.3343 51.4196 52.8848 52.0986 52.8848Z",
    fill: "#211242"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 52.8848C56.2201 52.8848 56.7705 52.3343 56.7705 51.6553C56.7705 50.9763 56.2201 50.4258 55.541 50.4258C54.862 50.4258 54.3115 50.9763 54.3115 51.6553C54.3115 52.3343 54.862 52.8848 55.541 52.8848Z",
    fill: "#211242"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 52.8848C59.6625 52.8848 60.2129 52.3343 60.2129 51.6553C60.2129 50.9763 59.6625 50.4258 58.9834 50.4258C58.3044 50.4258 57.7539 50.9763 57.7539 51.6553C57.7539 52.3343 58.3044 52.8848 58.9834 52.8848Z",
    fill: "#211242"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 52.8848C63.1048 52.8848 63.6553 52.3343 63.6553 51.6553C63.6553 50.9763 63.1048 50.4258 62.4258 50.4258C61.7468 50.4258 61.1963 50.9763 61.1963 51.6553C61.1963 52.3343 61.7468 52.8848 62.4258 52.8848Z",
    fill: "#211242"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 52.8848C66.5482 52.8848 67.0987 52.3343 67.0987 51.6553C67.0987 50.9763 66.5482 50.4258 65.8692 50.4258C65.1901 50.4258 64.6396 50.9763 64.6396 51.6553C64.6396 52.3343 65.1901 52.8848 65.8692 52.8848Z",
    fill: "#211242"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 49.4424C14.9085 49.4424 15.459 48.8919 15.459 48.2129C15.459 47.5339 14.9085 46.9834 14.2295 46.9834C13.5505 46.9834 13 47.5339 13 48.2129C13 48.8919 13.5505 49.4424 14.2295 49.4424Z",
    fill: "#211242"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 49.4424C18.3509 49.4424 18.9014 48.8919 18.9014 48.2129C18.9014 47.5339 18.3509 46.9834 17.6719 46.9834C16.9929 46.9834 16.4424 47.5339 16.4424 48.2129C16.4424 48.8919 16.9929 49.4424 17.6719 49.4424Z",
    fill: "#211242"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 49.4424C21.7933 49.4424 22.3438 48.8919 22.3438 48.2129C22.3438 47.5339 21.7933 46.9834 21.1143 46.9834C20.4352 46.9834 19.8848 47.5339 19.8848 48.2129C19.8848 48.8919 20.4352 49.4424 21.1143 49.4424Z",
    fill: "#211242"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 49.4424C25.2367 49.4424 25.7871 48.8919 25.7871 48.2129C25.7871 47.5339 25.2367 46.9834 24.5576 46.9834C23.8786 46.9834 23.3281 47.5339 23.3281 48.2129C23.3281 48.8919 23.8786 49.4424 24.5576 49.4424Z",
    fill: "#211242"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M28 49.4424C28.6791 49.4424 29.2295 48.8919 29.2295 48.2129C29.2295 47.5339 28.6791 46.9834 28 46.9834C27.321 46.9834 26.7705 47.5339 26.7705 48.2129C26.7705 48.8919 27.321 49.4424 28 49.4424Z",
    fill: "#211242"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 49.4424C32.1214 49.4424 32.6719 48.8919 32.6719 48.2129C32.6719 47.5339 32.1214 46.9834 31.4424 46.9834C30.7634 46.9834 30.2129 47.5339 30.2129 48.2129C30.2129 48.8919 30.7634 49.4424 31.4424 49.4424Z",
    fill: "#211242"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 49.4424C35.5638 49.4424 36.1143 48.8919 36.1143 48.2129C36.1143 47.5339 35.5638 46.9834 34.8848 46.9834C34.2057 46.9834 33.6553 47.5339 33.6553 48.2129C33.6553 48.8919 34.2057 49.4424 34.8848 49.4424Z",
    fill: "#211242"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 49.4424C39.0072 49.4424 39.5576 48.8919 39.5576 48.2129C39.5576 47.5339 39.0072 46.9834 38.3281 46.9834C37.6491 46.9834 37.0986 47.5339 37.0986 48.2129C37.0986 48.8919 37.6491 49.4424 38.3281 49.4424Z",
    fill: "#211242"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 49.4424C42.4496 49.4424 43 48.8919 43 48.2129C43 47.5339 42.4496 46.9834 41.7705 46.9834C41.0915 46.9834 40.541 47.5339 40.541 48.2129C40.541 48.8919 41.0915 49.4424 41.7705 49.4424Z",
    fill: "#211242"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 49.4424C45.8919 49.4424 46.4424 48.8919 46.4424 48.2129C46.4424 47.5339 45.8919 46.9834 45.2129 46.9834C44.5339 46.9834 43.9834 47.5339 43.9834 48.2129C43.9834 48.8919 44.5339 49.4424 45.2129 49.4424Z",
    fill: "#211242"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 49.4424C49.3343 49.4424 49.8848 48.8919 49.8848 48.2129C49.8848 47.5339 49.3343 46.9834 48.6553 46.9834C47.9763 46.9834 47.4258 47.5339 47.4258 48.2129C47.4258 48.8919 47.9763 49.4424 48.6553 49.4424Z",
    fill: "#211242"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 49.4424C52.7777 49.4424 53.3282 48.8919 53.3282 48.2129C53.3282 47.5339 52.7777 46.9834 52.0986 46.9834C51.4196 46.9834 50.8691 47.5339 50.8691 48.2129C50.8691 48.8919 51.4196 49.4424 52.0986 49.4424Z",
    fill: "#211242"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 49.4424C56.2201 49.4424 56.7705 48.8919 56.7705 48.2129C56.7705 47.5339 56.2201 46.9834 55.541 46.9834C54.862 46.9834 54.3115 47.5339 54.3115 48.2129C54.3115 48.8919 54.862 49.4424 55.541 49.4424Z",
    fill: "#211242"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 49.4424C59.6625 49.4424 60.2129 48.8919 60.2129 48.2129C60.2129 47.5339 59.6625 46.9834 58.9834 46.9834C58.3044 46.9834 57.7539 47.5339 57.7539 48.2129C57.7539 48.8919 58.3044 49.4424 58.9834 49.4424Z",
    fill: "#211242"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 49.4424C63.1048 49.4424 63.6553 48.8919 63.6553 48.2129C63.6553 47.5339 63.1048 46.9834 62.4258 46.9834C61.7468 46.9834 61.1963 47.5339 61.1963 48.2129C61.1963 48.8919 61.7468 49.4424 62.4258 49.4424Z",
    fill: "#211242"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 49.4424C66.5482 49.4424 67.0987 48.8919 67.0987 48.2129C67.0987 47.5339 66.5482 46.9834 65.8692 46.9834C65.1901 46.9834 64.6396 47.5339 64.6396 48.2129C64.6396 48.8919 65.1901 49.4424 65.8692 49.4424Z",
    fill: "#211242"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 46C14.9085 46 15.459 45.4496 15.459 44.7705C15.459 44.0915 14.9085 43.541 14.2295 43.541C13.5505 43.541 13 44.0915 13 44.7705C13 45.4496 13.5505 46 14.2295 46Z",
    fill: "#211242"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 46C18.3509 46 18.9014 45.4496 18.9014 44.7705C18.9014 44.0915 18.3509 43.541 17.6719 43.541C16.9929 43.541 16.4424 44.0915 16.4424 44.7705C16.4424 45.4496 16.9929 46 17.6719 46Z",
    fill: "#211242"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 46C21.7933 46 22.3438 45.4496 22.3438 44.7705C22.3438 44.0915 21.7933 43.541 21.1143 43.541C20.4352 43.541 19.8848 44.0915 19.8848 44.7705C19.8848 45.4496 20.4352 46 21.1143 46Z",
    fill: "#211242"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 46C25.2367 46 25.7871 45.4496 25.7871 44.7705C25.7871 44.0915 25.2367 43.541 24.5576 43.541C23.8786 43.541 23.3281 44.0915 23.3281 44.7705C23.3281 45.4496 23.8786 46 24.5576 46Z",
    fill: "#211242"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46C28.6791 46 29.2295 45.4496 29.2295 44.7705C29.2295 44.0915 28.6791 43.541 28 43.541C27.321 43.541 26.7705 44.0915 26.7705 44.7705C26.7705 45.4496 27.321 46 28 46Z",
    fill: "#211242"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 46C32.1214 46 32.6719 45.4496 32.6719 44.7705C32.6719 44.0915 32.1214 43.541 31.4424 43.541C30.7634 43.541 30.2129 44.0915 30.2129 44.7705C30.2129 45.4496 30.7634 46 31.4424 46Z",
    fill: "#211242"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 46C35.5638 46 36.1143 45.4496 36.1143 44.7705C36.1143 44.0915 35.5638 43.541 34.8848 43.541C34.2057 43.541 33.6553 44.0915 33.6553 44.7705C33.6553 45.4496 34.2057 46 34.8848 46Z",
    fill: "#211242"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 46C39.0072 46 39.5576 45.4496 39.5576 44.7705C39.5576 44.0915 39.0072 43.541 38.3281 43.541C37.6491 43.541 37.0986 44.0915 37.0986 44.7705C37.0986 45.4496 37.6491 46 38.3281 46Z",
    fill: "#211242"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 46C42.4496 46 43 45.4496 43 44.7705C43 44.0915 42.4496 43.541 41.7705 43.541C41.0915 43.541 40.541 44.0915 40.541 44.7705C40.541 45.4496 41.0915 46 41.7705 46Z",
    fill: "#211242"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 46C45.8919 46 46.4424 45.4496 46.4424 44.7705C46.4424 44.0915 45.8919 43.541 45.2129 43.541C44.5339 43.541 43.9834 44.0915 43.9834 44.7705C43.9834 45.4496 44.5339 46 45.2129 46Z",
    fill: "#211242"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 46C49.3343 46 49.8848 45.4496 49.8848 44.7705C49.8848 44.0915 49.3343 43.541 48.6553 43.541C47.9763 43.541 47.4258 44.0915 47.4258 44.7705C47.4258 45.4496 47.9763 46 48.6553 46Z",
    fill: "#211242"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 46C52.7777 46 53.3282 45.4496 53.3282 44.7705C53.3282 44.0915 52.7777 43.541 52.0986 43.541C51.4196 43.541 50.8691 44.0915 50.8691 44.7705C50.8691 45.4496 51.4196 46 52.0986 46Z",
    fill: "#211242"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 46C56.2201 46 56.7705 45.4496 56.7705 44.7705C56.7705 44.0915 56.2201 43.541 55.541 43.541C54.862 43.541 54.3115 44.0915 54.3115 44.7705C54.3115 45.4496 54.862 46 55.541 46Z",
    fill: "#211242"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 46C59.6625 46 60.2129 45.4496 60.2129 44.7705C60.2129 44.0915 59.6625 43.541 58.9834 43.541C58.3044 43.541 57.7539 44.0915 57.7539 44.7705C57.7539 45.4496 58.3044 46 58.9834 46Z",
    fill: "#211242"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 46C63.1048 46 63.6553 45.4496 63.6553 44.7705C63.6553 44.0915 63.1048 43.541 62.4258 43.541C61.7468 43.541 61.1963 44.0915 61.1963 44.7705C61.1963 45.4496 61.7468 46 62.4258 46Z",
    fill: "#211242"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 46C66.5482 46 67.0987 45.4496 67.0987 44.7705C67.0987 44.0915 66.5482 43.541 65.8692 43.541C65.1901 43.541 64.6396 44.0915 64.6396 44.7705C64.6396 45.4496 65.1901 46 65.8692 46Z",
    fill: "#211242"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 42.5576C14.9085 42.5576 15.459 42.0072 15.459 41.3281C15.459 40.6491 14.9085 40.0986 14.2295 40.0986C13.5505 40.0986 13 40.6491 13 41.3281C13 42.0072 13.5505 42.5576 14.2295 42.5576Z",
    fill: "#211242"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 42.5576C18.3509 42.5576 18.9014 42.0072 18.9014 41.3281C18.9014 40.6491 18.3509 40.0986 17.6719 40.0986C16.9929 40.0986 16.4424 40.6491 16.4424 41.3281C16.4424 42.0072 16.9929 42.5576 17.6719 42.5576Z",
    fill: "#211242"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 42.5576C21.7933 42.5576 22.3438 42.0072 22.3438 41.3281C22.3438 40.6491 21.7933 40.0986 21.1143 40.0986C20.4352 40.0986 19.8848 40.6491 19.8848 41.3281C19.8848 42.0072 20.4352 42.5576 21.1143 42.5576Z",
    fill: "#211242"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 42.5576C25.2367 42.5576 25.7871 42.0072 25.7871 41.3281C25.7871 40.6491 25.2367 40.0986 24.5576 40.0986C23.8786 40.0986 23.3281 40.6491 23.3281 41.3281C23.3281 42.0072 23.8786 42.5576 24.5576 42.5576Z",
    fill: "#211242"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M28 42.5576C28.6791 42.5576 29.2295 42.0072 29.2295 41.3281C29.2295 40.6491 28.6791 40.0986 28 40.0986C27.321 40.0986 26.7705 40.6491 26.7705 41.3281C26.7705 42.0072 27.321 42.5576 28 42.5576Z",
    fill: "#211242"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 42.5576C32.1214 42.5576 32.6719 42.0072 32.6719 41.3281C32.6719 40.6491 32.1214 40.0986 31.4424 40.0986C30.7634 40.0986 30.2129 40.6491 30.2129 41.3281C30.2129 42.0072 30.7634 42.5576 31.4424 42.5576Z",
    fill: "#211242"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 42.5576C35.5638 42.5576 36.1143 42.0072 36.1143 41.3281C36.1143 40.6491 35.5638 40.0986 34.8848 40.0986C34.2057 40.0986 33.6553 40.6491 33.6553 41.3281C33.6553 42.0072 34.2057 42.5576 34.8848 42.5576Z",
    fill: "#211242"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 42.5576C39.0072 42.5576 39.5576 42.0072 39.5576 41.3281C39.5576 40.6491 39.0072 40.0986 38.3281 40.0986C37.6491 40.0986 37.0986 40.6491 37.0986 41.3281C37.0986 42.0072 37.6491 42.5576 38.3281 42.5576Z",
    fill: "#211242"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 42.5576C42.4496 42.5576 43 42.0072 43 41.3281C43 40.6491 42.4496 40.0986 41.7705 40.0986C41.0915 40.0986 40.541 40.6491 40.541 41.3281C40.541 42.0072 41.0915 42.5576 41.7705 42.5576Z",
    fill: "#211242"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 42.5576C45.8919 42.5576 46.4424 42.0072 46.4424 41.3281C46.4424 40.6491 45.8919 40.0986 45.2129 40.0986C44.5339 40.0986 43.9834 40.6491 43.9834 41.3281C43.9834 42.0072 44.5339 42.5576 45.2129 42.5576Z",
    fill: "#211242"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 42.5576C49.3343 42.5576 49.8848 42.0072 49.8848 41.3281C49.8848 40.6491 49.3343 40.0986 48.6553 40.0986C47.9763 40.0986 47.4258 40.6491 47.4258 41.3281C47.4258 42.0072 47.9763 42.5576 48.6553 42.5576Z",
    fill: "#211242"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 42.5576C52.7777 42.5576 53.3282 42.0072 53.3282 41.3281C53.3282 40.6491 52.7777 40.0986 52.0986 40.0986C51.4196 40.0986 50.8691 40.6491 50.8691 41.3281C50.8691 42.0072 51.4196 42.5576 52.0986 42.5576Z",
    fill: "#211242"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 42.5576C56.2201 42.5576 56.7705 42.0072 56.7705 41.3281C56.7705 40.6491 56.2201 40.0986 55.541 40.0986C54.862 40.0986 54.3115 40.6491 54.3115 41.3281C54.3115 42.0072 54.862 42.5576 55.541 42.5576Z",
    fill: "#211242"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 42.5576C59.6625 42.5576 60.2129 42.0072 60.2129 41.3281C60.2129 40.6491 59.6625 40.0986 58.9834 40.0986C58.3044 40.0986 57.7539 40.6491 57.7539 41.3281C57.7539 42.0072 58.3044 42.5576 58.9834 42.5576Z",
    fill: "#211242"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 42.5576C63.1048 42.5576 63.6553 42.0072 63.6553 41.3281C63.6553 40.6491 63.1048 40.0986 62.4258 40.0986C61.7468 40.0986 61.1963 40.6491 61.1963 41.3281C61.1963 42.0072 61.7468 42.5576 62.4258 42.5576Z",
    fill: "#211242"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 42.5576C66.5482 42.5576 67.0987 42.0072 67.0987 41.3281C67.0987 40.6491 66.5482 40.0986 65.8692 40.0986C65.1901 40.0986 64.6396 40.6491 64.6396 41.3281C64.6396 42.0072 65.1901 42.5576 65.8692 42.5576Z",
    fill: "#211242"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 39.1143C14.9085 39.1143 15.459 38.5638 15.459 37.8848C15.459 37.2057 14.9085 36.6553 14.2295 36.6553C13.5505 36.6553 13 37.2057 13 37.8848C13 38.5638 13.5505 39.1143 14.2295 39.1143Z",
    fill: "#211242"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 39.1143C18.3509 39.1143 18.9014 38.5638 18.9014 37.8848C18.9014 37.2057 18.3509 36.6553 17.6719 36.6553C16.9929 36.6553 16.4424 37.2057 16.4424 37.8848C16.4424 38.5638 16.9929 39.1143 17.6719 39.1143Z",
    fill: "#211242"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 39.1153C21.7933 39.1153 22.3438 38.5648 22.3438 37.8858C22.3438 37.2067 21.7933 36.6562 21.1143 36.6562C20.4352 36.6562 19.8848 37.2067 19.8848 37.8858C19.8848 38.5648 20.4352 39.1153 21.1143 39.1153Z",
    fill: "#211242"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 39.1153C25.2367 39.1153 25.7871 38.5648 25.7871 37.8858C25.7871 37.2067 25.2367 36.6562 24.5576 36.6562C23.8786 36.6562 23.3281 37.2067 23.3281 37.8858C23.3281 38.5648 23.8786 39.1153 24.5576 39.1153Z",
    fill: "#211242"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39.1143C28.6791 39.1143 29.2295 38.5638 29.2295 37.8848C29.2295 37.2057 28.6791 36.6553 28 36.6553C27.321 36.6553 26.7705 37.2057 26.7705 37.8848C26.7705 38.5638 27.321 39.1143 28 39.1143Z",
    fill: "#211242"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 39.1143C32.1214 39.1143 32.6719 38.5638 32.6719 37.8848C32.6719 37.2057 32.1214 36.6553 31.4424 36.6553C30.7634 36.6553 30.2129 37.2057 30.2129 37.8848C30.2129 38.5638 30.7634 39.1143 31.4424 39.1143Z",
    fill: "#211242"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 39.1153C35.5638 39.1153 36.1143 38.5648 36.1143 37.8858C36.1143 37.2067 35.5638 36.6562 34.8848 36.6562C34.2057 36.6562 33.6553 37.2067 33.6553 37.8858C33.6553 38.5648 34.2057 39.1153 34.8848 39.1153Z",
    fill: "#211242"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 39.1153C39.0072 39.1153 39.5576 38.5648 39.5576 37.8858C39.5576 37.2067 39.0072 36.6562 38.3281 36.6562C37.6491 36.6562 37.0986 37.2067 37.0986 37.8858C37.0986 38.5648 37.6491 39.1153 38.3281 39.1153Z",
    fill: "#211242"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 39.1143C42.4496 39.1143 43 38.5638 43 37.8848C43 37.2057 42.4496 36.6553 41.7705 36.6553C41.0915 36.6553 40.541 37.2057 40.541 37.8848C40.541 38.5638 41.0915 39.1143 41.7705 39.1143Z",
    fill: "#211242"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 39.1143C45.8919 39.1143 46.4424 38.5638 46.4424 37.8848C46.4424 37.2057 45.8919 36.6553 45.2129 36.6553C44.5339 36.6553 43.9834 37.2057 43.9834 37.8848C43.9834 38.5638 44.5339 39.1143 45.2129 39.1143Z",
    fill: "#211242"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 39.1153C49.3343 39.1153 49.8848 38.5648 49.8848 37.8858C49.8848 37.2067 49.3343 36.6562 48.6553 36.6562C47.9763 36.6562 47.4258 37.2067 47.4258 37.8858C47.4258 38.5648 47.9763 39.1153 48.6553 39.1153Z",
    fill: "#211242"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 39.1153C52.7777 39.1153 53.3282 38.5648 53.3282 37.8858C53.3282 37.2067 52.7777 36.6562 52.0986 36.6562C51.4196 36.6562 50.8691 37.2067 50.8691 37.8858C50.8691 38.5648 51.4196 39.1153 52.0986 39.1153Z",
    fill: "#211242"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 39.1143C56.2201 39.1143 56.7705 38.5638 56.7705 37.8848C56.7705 37.2057 56.2201 36.6553 55.541 36.6553C54.862 36.6553 54.3115 37.2057 54.3115 37.8848C54.3115 38.5638 54.862 39.1143 55.541 39.1143Z",
    fill: "#211242"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 39.1143C59.6625 39.1143 60.2129 38.5638 60.2129 37.8848C60.2129 37.2057 59.6625 36.6553 58.9834 36.6553C58.3044 36.6553 57.7539 37.2057 57.7539 37.8848C57.7539 38.5638 58.3044 39.1143 58.9834 39.1143Z",
    fill: "#211242"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 39.1153C63.1048 39.1153 63.6553 38.5648 63.6553 37.8858C63.6553 37.2067 63.1048 36.6562 62.4258 36.6562C61.7468 36.6562 61.1963 37.2067 61.1963 37.8858C61.1963 38.5648 61.7468 39.1153 62.4258 39.1153Z",
    fill: "#211242"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 39.1153C66.5482 39.1153 67.0987 38.5648 67.0987 37.8858C67.0987 37.2067 66.5482 36.6562 65.8692 36.6562C65.1901 36.6562 64.6396 37.2067 64.6396 37.8858C64.6396 38.5648 65.1901 39.1153 65.8692 39.1153Z",
    fill: "#211242"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 35.6719C14.9085 35.6719 15.459 35.1214 15.459 34.4424C15.459 33.7634 14.9085 33.2129 14.2295 33.2129C13.5505 33.2129 13 33.7634 13 34.4424C13 35.1214 13.5505 35.6719 14.2295 35.6719Z",
    fill: "#211242"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 35.6719C18.3509 35.6719 18.9014 35.1214 18.9014 34.4424C18.9014 33.7634 18.3509 33.2129 17.6719 33.2129C16.9929 33.2129 16.4424 33.7634 16.4424 34.4424C16.4424 35.1214 16.9929 35.6719 17.6719 35.6719Z",
    fill: "#211242"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 35.6719C21.7933 35.6719 22.3438 35.1214 22.3438 34.4424C22.3438 33.7634 21.7933 33.2129 21.1143 33.2129C20.4352 33.2129 19.8848 33.7634 19.8848 34.4424C19.8848 35.1214 20.4352 35.6719 21.1143 35.6719Z",
    fill: "#211242"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 35.6719C25.2367 35.6719 25.7871 35.1214 25.7871 34.4424C25.7871 33.7634 25.2367 33.2129 24.5576 33.2129C23.8786 33.2129 23.3281 33.7634 23.3281 34.4424C23.3281 35.1214 23.8786 35.6719 24.5576 35.6719Z",
    fill: "#211242"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M28 35.6719C28.6791 35.6719 29.2295 35.1214 29.2295 34.4424C29.2295 33.7634 28.6791 33.2129 28 33.2129C27.321 33.2129 26.7705 33.7634 26.7705 34.4424C26.7705 35.1214 27.321 35.6719 28 35.6719Z",
    fill: "#211242"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 35.6719C32.1214 35.6719 32.6719 35.1214 32.6719 34.4424C32.6719 33.7634 32.1214 33.2129 31.4424 33.2129C30.7634 33.2129 30.2129 33.7634 30.2129 34.4424C30.2129 35.1214 30.7634 35.6719 31.4424 35.6719Z",
    fill: "#211242"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 35.6719C35.5638 35.6719 36.1143 35.1214 36.1143 34.4424C36.1143 33.7634 35.5638 33.2129 34.8848 33.2129C34.2057 33.2129 33.6553 33.7634 33.6553 34.4424C33.6553 35.1214 34.2057 35.6719 34.8848 35.6719Z",
    fill: "#211242"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 35.6719C39.0072 35.6719 39.5576 35.1214 39.5576 34.4424C39.5576 33.7634 39.0072 33.2129 38.3281 33.2129C37.6491 33.2129 37.0986 33.7634 37.0986 34.4424C37.0986 35.1214 37.6491 35.6719 38.3281 35.6719Z",
    fill: "#211242"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 35.6719C42.4496 35.6719 43 35.1214 43 34.4424C43 33.7634 42.4496 33.2129 41.7705 33.2129C41.0915 33.2129 40.541 33.7634 40.541 34.4424C40.541 35.1214 41.0915 35.6719 41.7705 35.6719Z",
    fill: "#211242"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 35.6719C45.8919 35.6719 46.4424 35.1214 46.4424 34.4424C46.4424 33.7634 45.8919 33.2129 45.2129 33.2129C44.5339 33.2129 43.9834 33.7634 43.9834 34.4424C43.9834 35.1214 44.5339 35.6719 45.2129 35.6719Z",
    fill: "#211242"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 35.6719C49.3343 35.6719 49.8848 35.1214 49.8848 34.4424C49.8848 33.7634 49.3343 33.2129 48.6553 33.2129C47.9763 33.2129 47.4258 33.7634 47.4258 34.4424C47.4258 35.1214 47.9763 35.6719 48.6553 35.6719Z",
    fill: "#211242"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 35.6719C52.7777 35.6719 53.3282 35.1214 53.3282 34.4424C53.3282 33.7634 52.7777 33.2129 52.0986 33.2129C51.4196 33.2129 50.8691 33.7634 50.8691 34.4424C50.8691 35.1214 51.4196 35.6719 52.0986 35.6719Z",
    fill: "#211242"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 35.6719C56.2201 35.6719 56.7705 35.1214 56.7705 34.4424C56.7705 33.7634 56.2201 33.2129 55.541 33.2129C54.862 33.2129 54.3115 33.7634 54.3115 34.4424C54.3115 35.1214 54.862 35.6719 55.541 35.6719Z",
    fill: "#211242"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 35.6719C59.6625 35.6719 60.2129 35.1214 60.2129 34.4424C60.2129 33.7634 59.6625 33.2129 58.9834 33.2129C58.3044 33.2129 57.7539 33.7634 57.7539 34.4424C57.7539 35.1214 58.3044 35.6719 58.9834 35.6719Z",
    fill: "#211242"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 35.6719C63.1048 35.6719 63.6553 35.1214 63.6553 34.4424C63.6553 33.7634 63.1048 33.2129 62.4258 33.2129C61.7468 33.2129 61.1963 33.7634 61.1963 34.4424C61.1963 35.1214 61.7468 35.6719 62.4258 35.6719Z",
    fill: "#211242"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 35.6719C66.5482 35.6719 67.0987 35.1214 67.0987 34.4424C67.0987 33.7634 66.5482 33.2129 65.8692 33.2129C65.1901 33.2129 64.6396 33.7634 64.6396 34.4424C64.6396 35.1214 65.1901 35.6719 65.8692 35.6719Z",
    fill: "#211242"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 32.2295C14.9085 32.2295 15.459 31.6791 15.459 31C15.459 30.321 14.9085 29.7705 14.2295 29.7705C13.5505 29.7705 13 30.321 13 31C13 31.6791 13.5505 32.2295 14.2295 32.2295Z",
    fill: "#211242"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 32.2295C18.3509 32.2295 18.9014 31.6791 18.9014 31C18.9014 30.321 18.3509 29.7705 17.6719 29.7705C16.9929 29.7705 16.4424 30.321 16.4424 31C16.4424 31.6791 16.9929 32.2295 17.6719 32.2295Z",
    fill: "#211242"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 32.2295C21.7933 32.2295 22.3438 31.6791 22.3438 31C22.3438 30.321 21.7933 29.7705 21.1143 29.7705C20.4352 29.7705 19.8848 30.321 19.8848 31C19.8848 31.6791 20.4352 32.2295 21.1143 32.2295Z",
    fill: "#211242"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 32.2295C25.2367 32.2295 25.7871 31.6791 25.7871 31C25.7871 30.321 25.2367 29.7705 24.5576 29.7705C23.8786 29.7705 23.3281 30.321 23.3281 31C23.3281 31.6791 23.8786 32.2295 24.5576 32.2295Z",
    fill: "#211242"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32.2295C28.6791 32.2295 29.2295 31.6791 29.2295 31C29.2295 30.321 28.6791 29.7705 28 29.7705C27.321 29.7705 26.7705 30.321 26.7705 31C26.7705 31.6791 27.321 32.2295 28 32.2295Z",
    fill: "#211242"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 32.2295C32.1214 32.2295 32.6719 31.6791 32.6719 31C32.6719 30.321 32.1214 29.7705 31.4424 29.7705C30.7634 29.7705 30.2129 30.321 30.2129 31C30.2129 31.6791 30.7634 32.2295 31.4424 32.2295Z",
    fill: "#211242"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 32.2295C35.5638 32.2295 36.1143 31.6791 36.1143 31C36.1143 30.321 35.5638 29.7705 34.8848 29.7705C34.2057 29.7705 33.6553 30.321 33.6553 31C33.6553 31.6791 34.2057 32.2295 34.8848 32.2295Z",
    fill: "#211242"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 32.2295C39.0072 32.2295 39.5576 31.6791 39.5576 31C39.5576 30.321 39.0072 29.7705 38.3281 29.7705C37.6491 29.7705 37.0986 30.321 37.0986 31C37.0986 31.6791 37.6491 32.2295 38.3281 32.2295Z",
    fill: "#211242"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 32.2295C42.4496 32.2295 43 31.6791 43 31C43 30.321 42.4496 29.7705 41.7705 29.7705C41.0915 29.7705 40.541 30.321 40.541 31C40.541 31.6791 41.0915 32.2295 41.7705 32.2295Z",
    fill: "#211242"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 32.2295C45.8919 32.2295 46.4424 31.6791 46.4424 31C46.4424 30.321 45.8919 29.7705 45.2129 29.7705C44.5339 29.7705 43.9834 30.321 43.9834 31C43.9834 31.6791 44.5339 32.2295 45.2129 32.2295Z",
    fill: "#211242"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 32.2295C49.3343 32.2295 49.8848 31.6791 49.8848 31C49.8848 30.321 49.3343 29.7705 48.6553 29.7705C47.9763 29.7705 47.4258 30.321 47.4258 31C47.4258 31.6791 47.9763 32.2295 48.6553 32.2295Z",
    fill: "#211242"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 32.2295C52.7777 32.2295 53.3282 31.6791 53.3282 31C53.3282 30.321 52.7777 29.7705 52.0986 29.7705C51.4196 29.7705 50.8691 30.321 50.8691 31C50.8691 31.6791 51.4196 32.2295 52.0986 32.2295Z",
    fill: "#211242"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 32.2295C56.2201 32.2295 56.7705 31.6791 56.7705 31C56.7705 30.321 56.2201 29.7705 55.541 29.7705C54.862 29.7705 54.3115 30.321 54.3115 31C54.3115 31.6791 54.862 32.2295 55.541 32.2295Z",
    fill: "#211242"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 32.2295C59.6625 32.2295 60.2129 31.6791 60.2129 31C60.2129 30.321 59.6625 29.7705 58.9834 29.7705C58.3044 29.7705 57.7539 30.321 57.7539 31C57.7539 31.6791 58.3044 32.2295 58.9834 32.2295Z",
    fill: "#211242"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 32.2295C63.1048 32.2295 63.6553 31.6791 63.6553 31C63.6553 30.321 63.1048 29.7705 62.4258 29.7705C61.7468 29.7705 61.1963 30.321 61.1963 31C61.1963 31.6791 61.7468 32.2295 62.4258 32.2295Z",
    fill: "#211242"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 32.2295C66.5482 32.2295 67.0987 31.6791 67.0987 31C67.0987 30.321 66.5482 29.7705 65.8692 29.7705C65.1901 29.7705 64.6396 30.321 64.6396 31C64.6396 31.6791 65.1901 32.2295 65.8692 32.2295Z",
    fill: "#211242"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 28.7871C14.9085 28.7871 15.459 28.2367 15.459 27.5576C15.459 26.8786 14.9085 26.3281 14.2295 26.3281C13.5505 26.3281 13 26.8786 13 27.5576C13 28.2367 13.5505 28.7871 14.2295 28.7871Z",
    fill: "#211242"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 28.7871C18.3509 28.7871 18.9014 28.2367 18.9014 27.5576C18.9014 26.8786 18.3509 26.3281 17.6719 26.3281C16.9929 26.3281 16.4424 26.8786 16.4424 27.5576C16.4424 28.2367 16.9929 28.7871 17.6719 28.7871Z",
    fill: "#211242"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 28.7871C21.7933 28.7871 22.3438 28.2367 22.3438 27.5576C22.3438 26.8786 21.7933 26.3281 21.1143 26.3281C20.4352 26.3281 19.8848 26.8786 19.8848 27.5576C19.8848 28.2367 20.4352 28.7871 21.1143 28.7871Z",
    fill: "#211242"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 28.7871C25.2367 28.7871 25.7871 28.2367 25.7871 27.5576C25.7871 26.8786 25.2367 26.3281 24.5576 26.3281C23.8786 26.3281 23.3281 26.8786 23.3281 27.5576C23.3281 28.2367 23.8786 28.7871 24.5576 28.7871Z",
    fill: "#211242"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28.7871C28.6791 28.7871 29.2295 28.2367 29.2295 27.5576C29.2295 26.8786 28.6791 26.3281 28 26.3281C27.321 26.3281 26.7705 26.8786 26.7705 27.5576C26.7705 28.2367 27.321 28.7871 28 28.7871Z",
    fill: "#211242"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 28.7871C32.1214 28.7871 32.6719 28.2367 32.6719 27.5576C32.6719 26.8786 32.1214 26.3281 31.4424 26.3281C30.7634 26.3281 30.2129 26.8786 30.2129 27.5576C30.2129 28.2367 30.7634 28.7871 31.4424 28.7871Z",
    fill: "#211242"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 28.7871C35.5638 28.7871 36.1143 28.2367 36.1143 27.5576C36.1143 26.8786 35.5638 26.3281 34.8848 26.3281C34.2057 26.3281 33.6553 26.8786 33.6553 27.5576C33.6553 28.2367 34.2057 28.7871 34.8848 28.7871Z",
    fill: "#211242"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 28.7871C39.0072 28.7871 39.5576 28.2367 39.5576 27.5576C39.5576 26.8786 39.0072 26.3281 38.3281 26.3281C37.6491 26.3281 37.0986 26.8786 37.0986 27.5576C37.0986 28.2367 37.6491 28.7871 38.3281 28.7871Z",
    fill: "#211242"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 28.7871C42.4496 28.7871 43 28.2367 43 27.5576C43 26.8786 42.4496 26.3281 41.7705 26.3281C41.0915 26.3281 40.541 26.8786 40.541 27.5576C40.541 28.2367 41.0915 28.7871 41.7705 28.7871Z",
    fill: "#211242"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 28.7871C45.8919 28.7871 46.4424 28.2367 46.4424 27.5576C46.4424 26.8786 45.8919 26.3281 45.2129 26.3281C44.5339 26.3281 43.9834 26.8786 43.9834 27.5576C43.9834 28.2367 44.5339 28.7871 45.2129 28.7871Z",
    fill: "#211242"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 28.7871C49.3343 28.7871 49.8848 28.2367 49.8848 27.5576C49.8848 26.8786 49.3343 26.3281 48.6553 26.3281C47.9763 26.3281 47.4258 26.8786 47.4258 27.5576C47.4258 28.2367 47.9763 28.7871 48.6553 28.7871Z",
    fill: "#211242"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 28.7871C52.7777 28.7871 53.3282 28.2367 53.3282 27.5576C53.3282 26.8786 52.7777 26.3281 52.0986 26.3281C51.4196 26.3281 50.8691 26.8786 50.8691 27.5576C50.8691 28.2367 51.4196 28.7871 52.0986 28.7871Z",
    fill: "#211242"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 28.7871C56.2201 28.7871 56.7705 28.2367 56.7705 27.5576C56.7705 26.8786 56.2201 26.3281 55.541 26.3281C54.862 26.3281 54.3115 26.8786 54.3115 27.5576C54.3115 28.2367 54.862 28.7871 55.541 28.7871Z",
    fill: "#211242"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 28.7871C59.6625 28.7871 60.2129 28.2367 60.2129 27.5576C60.2129 26.8786 59.6625 26.3281 58.9834 26.3281C58.3044 26.3281 57.7539 26.8786 57.7539 27.5576C57.7539 28.2367 58.3044 28.7871 58.9834 28.7871Z",
    fill: "#211242"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 28.7871C63.1048 28.7871 63.6553 28.2367 63.6553 27.5576C63.6553 26.8786 63.1048 26.3281 62.4258 26.3281C61.7468 26.3281 61.1963 26.8786 61.1963 27.5576C61.1963 28.2367 61.7468 28.7871 62.4258 28.7871Z",
    fill: "#211242"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 28.7871C66.5482 28.7871 67.0987 28.2367 67.0987 27.5576C67.0987 26.8786 66.5482 26.3281 65.8692 26.3281C65.1901 26.3281 64.6396 26.8786 64.6396 27.5576C64.6396 28.2367 65.1901 28.7871 65.8692 28.7871Z",
    fill: "#211242"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 25.3438C14.9085 25.3438 15.459 24.7933 15.459 24.1143C15.459 23.4352 14.9085 22.8848 14.2295 22.8848C13.5505 22.8848 13 23.4352 13 24.1143C13 24.7933 13.5505 25.3438 14.2295 25.3438Z",
    fill: "#211242"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 25.3438C18.3509 25.3438 18.9014 24.7933 18.9014 24.1143C18.9014 23.4352 18.3509 22.8848 17.6719 22.8848C16.9929 22.8848 16.4424 23.4352 16.4424 24.1143C16.4424 24.7933 16.9929 25.3438 17.6719 25.3438Z",
    fill: "#211242"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 25.3438C21.7933 25.3438 22.3438 24.7933 22.3438 24.1143C22.3438 23.4352 21.7933 22.8848 21.1143 22.8848C20.4352 22.8848 19.8848 23.4352 19.8848 24.1143C19.8848 24.7933 20.4352 25.3438 21.1143 25.3438Z",
    fill: "#211242"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 25.3438C25.2367 25.3438 25.7871 24.7933 25.7871 24.1143C25.7871 23.4352 25.2367 22.8848 24.5576 22.8848C23.8786 22.8848 23.3281 23.4352 23.3281 24.1143C23.3281 24.7933 23.8786 25.3438 24.5576 25.3438Z",
    fill: "#211242"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25.3438C28.6791 25.3438 29.2295 24.7933 29.2295 24.1143C29.2295 23.4352 28.6791 22.8848 28 22.8848C27.321 22.8848 26.7705 23.4352 26.7705 24.1143C26.7705 24.7933 27.321 25.3438 28 25.3438Z",
    fill: "#211242"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 25.3438C32.1214 25.3438 32.6719 24.7933 32.6719 24.1143C32.6719 23.4352 32.1214 22.8848 31.4424 22.8848C30.7634 22.8848 30.2129 23.4352 30.2129 24.1143C30.2129 24.7933 30.7634 25.3438 31.4424 25.3438Z",
    fill: "#211242"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 25.3438C35.5638 25.3438 36.1143 24.7933 36.1143 24.1143C36.1143 23.4352 35.5638 22.8848 34.8848 22.8848C34.2057 22.8848 33.6553 23.4352 33.6553 24.1143C33.6553 24.7933 34.2057 25.3438 34.8848 25.3438Z",
    fill: "#211242"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 25.3438C39.0072 25.3438 39.5576 24.7933 39.5576 24.1143C39.5576 23.4352 39.0072 22.8848 38.3281 22.8848C37.6491 22.8848 37.0986 23.4352 37.0986 24.1143C37.0986 24.7933 37.6491 25.3438 38.3281 25.3438Z",
    fill: "#211242"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 25.3438C42.4496 25.3438 43 24.7933 43 24.1143C43 23.4352 42.4496 22.8848 41.7705 22.8848C41.0915 22.8848 40.541 23.4352 40.541 24.1143C40.541 24.7933 41.0915 25.3438 41.7705 25.3438Z",
    fill: "#211242"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 25.3438C45.8919 25.3438 46.4424 24.7933 46.4424 24.1143C46.4424 23.4352 45.8919 22.8848 45.2129 22.8848C44.5339 22.8848 43.9834 23.4352 43.9834 24.1143C43.9834 24.7933 44.5339 25.3438 45.2129 25.3438Z",
    fill: "#211242"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 25.3438C49.3343 25.3438 49.8848 24.7933 49.8848 24.1143C49.8848 23.4352 49.3343 22.8848 48.6553 22.8848C47.9763 22.8848 47.4258 23.4352 47.4258 24.1143C47.4258 24.7933 47.9763 25.3438 48.6553 25.3438Z",
    fill: "#211242"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 25.3438C52.7777 25.3438 53.3282 24.7933 53.3282 24.1143C53.3282 23.4352 52.7777 22.8848 52.0986 22.8848C51.4196 22.8848 50.8691 23.4352 50.8691 24.1143C50.8691 24.7933 51.4196 25.3438 52.0986 25.3438Z",
    fill: "#211242"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 25.3438C56.2201 25.3438 56.7705 24.7933 56.7705 24.1143C56.7705 23.4352 56.2201 22.8848 55.541 22.8848C54.862 22.8848 54.3115 23.4352 54.3115 24.1143C54.3115 24.7933 54.862 25.3438 55.541 25.3438Z",
    fill: "#211242"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 25.3438C59.6625 25.3438 60.2129 24.7933 60.2129 24.1143C60.2129 23.4352 59.6625 22.8848 58.9834 22.8848C58.3044 22.8848 57.7539 23.4352 57.7539 24.1143C57.7539 24.7933 58.3044 25.3438 58.9834 25.3438Z",
    fill: "#211242"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 25.3438C63.1048 25.3438 63.6553 24.7933 63.6553 24.1143C63.6553 23.4352 63.1048 22.8848 62.4258 22.8848C61.7468 22.8848 61.1963 23.4352 61.1963 24.1143C61.1963 24.7933 61.7468 25.3438 62.4258 25.3438Z",
    fill: "#211242"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 25.3438C66.5482 25.3438 67.0987 24.7933 67.0987 24.1143C67.0987 23.4352 66.5482 22.8848 65.8692 22.8848C65.1901 22.8848 64.6396 23.4352 64.6396 24.1143C64.6396 24.7933 65.1901 25.3438 65.8692 25.3438Z",
    fill: "#211242"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 21.9014C14.9085 21.9014 15.459 21.3509 15.459 20.6719C15.459 19.9929 14.9085 19.4424 14.2295 19.4424C13.5505 19.4424 13 19.9929 13 20.6719C13 21.3509 13.5505 21.9014 14.2295 21.9014Z",
    fill: "#211242"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 21.9014C18.3509 21.9014 18.9014 21.3509 18.9014 20.6719C18.9014 19.9929 18.3509 19.4424 17.6719 19.4424C16.9929 19.4424 16.4424 19.9929 16.4424 20.6719C16.4424 21.3509 16.9929 21.9014 17.6719 21.9014Z",
    fill: "#211242"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 21.9014C21.7933 21.9014 22.3438 21.3509 22.3438 20.6719C22.3438 19.9929 21.7933 19.4424 21.1143 19.4424C20.4352 19.4424 19.8848 19.9929 19.8848 20.6719C19.8848 21.3509 20.4352 21.9014 21.1143 21.9014Z",
    fill: "#211242"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 21.9014C25.2367 21.9014 25.7871 21.3509 25.7871 20.6719C25.7871 19.9929 25.2367 19.4424 24.5576 19.4424C23.8786 19.4424 23.3281 19.9929 23.3281 20.6719C23.3281 21.3509 23.8786 21.9014 24.5576 21.9014Z",
    fill: "#211242"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M28 21.9014C28.6791 21.9014 29.2295 21.3509 29.2295 20.6719C29.2295 19.9929 28.6791 19.4424 28 19.4424C27.321 19.4424 26.7705 19.9929 26.7705 20.6719C26.7705 21.3509 27.321 21.9014 28 21.9014Z",
    fill: "#211242"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 21.9014C32.1214 21.9014 32.6719 21.3509 32.6719 20.6719C32.6719 19.9929 32.1214 19.4424 31.4424 19.4424C30.7634 19.4424 30.2129 19.9929 30.2129 20.6719C30.2129 21.3509 30.7634 21.9014 31.4424 21.9014Z",
    fill: "#211242"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 21.9014C35.5638 21.9014 36.1143 21.3509 36.1143 20.6719C36.1143 19.9929 35.5638 19.4424 34.8848 19.4424C34.2057 19.4424 33.6553 19.9929 33.6553 20.6719C33.6553 21.3509 34.2057 21.9014 34.8848 21.9014Z",
    fill: "#211242"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 21.9014C39.0072 21.9014 39.5576 21.3509 39.5576 20.6719C39.5576 19.9929 39.0072 19.4424 38.3281 19.4424C37.6491 19.4424 37.0986 19.9929 37.0986 20.6719C37.0986 21.3509 37.6491 21.9014 38.3281 21.9014Z",
    fill: "#211242"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 21.9014C42.4496 21.9014 43 21.3509 43 20.6719C43 19.9929 42.4496 19.4424 41.7705 19.4424C41.0915 19.4424 40.541 19.9929 40.541 20.6719C40.541 21.3509 41.0915 21.9014 41.7705 21.9014Z",
    fill: "#211242"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 21.9014C45.8919 21.9014 46.4424 21.3509 46.4424 20.6719C46.4424 19.9929 45.8919 19.4424 45.2129 19.4424C44.5339 19.4424 43.9834 19.9929 43.9834 20.6719C43.9834 21.3509 44.5339 21.9014 45.2129 21.9014Z",
    fill: "#211242"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 21.9014C49.3343 21.9014 49.8848 21.3509 49.8848 20.6719C49.8848 19.9929 49.3343 19.4424 48.6553 19.4424C47.9763 19.4424 47.4258 19.9929 47.4258 20.6719C47.4258 21.3509 47.9763 21.9014 48.6553 21.9014Z",
    fill: "#211242"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 21.9014C52.7777 21.9014 53.3282 21.3509 53.3282 20.6719C53.3282 19.9929 52.7777 19.4424 52.0986 19.4424C51.4196 19.4424 50.8691 19.9929 50.8691 20.6719C50.8691 21.3509 51.4196 21.9014 52.0986 21.9014Z",
    fill: "#211242"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 21.9014C56.2201 21.9014 56.7705 21.3509 56.7705 20.6719C56.7705 19.9929 56.2201 19.4424 55.541 19.4424C54.862 19.4424 54.3115 19.9929 54.3115 20.6719C54.3115 21.3509 54.862 21.9014 55.541 21.9014Z",
    fill: "#211242"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 21.9014C59.6625 21.9014 60.2129 21.3509 60.2129 20.6719C60.2129 19.9929 59.6625 19.4424 58.9834 19.4424C58.3044 19.4424 57.7539 19.9929 57.7539 20.6719C57.7539 21.3509 58.3044 21.9014 58.9834 21.9014Z",
    fill: "#211242"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 21.9014C63.1048 21.9014 63.6553 21.3509 63.6553 20.6719C63.6553 19.9929 63.1048 19.4424 62.4258 19.4424C61.7468 19.4424 61.1963 19.9929 61.1963 20.6719C61.1963 21.3509 61.7468 21.9014 62.4258 21.9014Z",
    fill: "#211242"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 21.9014C66.5482 21.9014 67.0987 21.3509 67.0987 20.6719C67.0987 19.9929 66.5482 19.4424 65.8692 19.4424C65.1901 19.4424 64.6396 19.9929 64.6396 20.6719C64.6396 21.3509 65.1901 21.9014 65.8692 21.9014Z",
    fill: "#211242"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2295 18.459C14.9085 18.459 15.459 17.9085 15.459 17.2295C15.459 16.5505 14.9085 16 14.2295 16C13.5505 16 13 16.5505 13 17.2295C13 17.9085 13.5505 18.459 14.2295 18.459Z",
    fill: "#211242"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 18.459C18.3509 18.459 18.9014 17.9085 18.9014 17.2295C18.9014 16.5505 18.3509 16 17.6719 16C16.9929 16 16.4424 16.5505 16.4424 17.2295C16.4424 17.9085 16.9929 18.459 17.6719 18.459Z",
    fill: "#211242"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 18.459C21.7933 18.459 22.3438 17.9085 22.3438 17.2295C22.3438 16.5505 21.7933 16 21.1143 16C20.4352 16 19.8848 16.5505 19.8848 17.2295C19.8848 17.9085 20.4352 18.459 21.1143 18.459Z",
    fill: "#211242"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5576 18.459C25.2367 18.459 25.7871 17.9085 25.7871 17.2295C25.7871 16.5505 25.2367 16 24.5576 16C23.8786 16 23.3281 16.5505 23.3281 17.2295C23.3281 17.9085 23.8786 18.459 24.5576 18.459Z",
    fill: "#211242"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18.459C28.6791 18.459 29.2295 17.9085 29.2295 17.2295C29.2295 16.5505 28.6791 16 28 16C27.321 16 26.7705 16.5505 26.7705 17.2295C26.7705 17.9085 27.321 18.459 28 18.459Z",
    fill: "#211242"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4424 18.459C32.1214 18.459 32.6719 17.9085 32.6719 17.2295C32.6719 16.5505 32.1214 16 31.4424 16C30.7634 16 30.2129 16.5505 30.2129 17.2295C30.2129 17.9085 30.7634 18.459 31.4424 18.459Z",
    fill: "#211242"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8848 18.459C35.5638 18.459 36.1143 17.9085 36.1143 17.2295C36.1143 16.5505 35.5638 16 34.8848 16C34.2057 16 33.6553 16.5505 33.6553 17.2295C33.6553 17.9085 34.2057 18.459 34.8848 18.459Z",
    fill: "#211242"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 18.459C39.0072 18.459 39.5576 17.9085 39.5576 17.2295C39.5576 16.5505 39.0072 16 38.3281 16C37.6491 16 37.0986 16.5505 37.0986 17.2295C37.0986 17.9085 37.6491 18.459 38.3281 18.459Z",
    fill: "#211242"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 18.459C42.4496 18.459 43 17.9085 43 17.2295C43 16.5505 42.4496 16 41.7705 16C41.0915 16 40.541 16.5505 40.541 17.2295C40.541 17.9085 41.0915 18.459 41.7705 18.459Z",
    fill: "#211242"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2129 18.459C45.8919 18.459 46.4424 17.9085 46.4424 17.2295C46.4424 16.5505 45.8919 16 45.2129 16C44.5339 16 43.9834 16.5505 43.9834 17.2295C43.9834 17.9085 44.5339 18.459 45.2129 18.459Z",
    fill: "#211242"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6553 18.459C49.3343 18.459 49.8848 17.9085 49.8848 17.2295C49.8848 16.5505 49.3343 16 48.6553 16C47.9763 16 47.4258 16.5505 47.4258 17.2295C47.4258 17.9085 47.9763 18.459 48.6553 18.459Z",
    fill: "#211242"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0986 18.459C52.7777 18.459 53.3282 17.9085 53.3282 17.2295C53.3282 16.5505 52.7777 16 52.0986 16C51.4196 16 50.8691 16.5505 50.8691 17.2295C50.8691 17.9085 51.4196 18.459 52.0986 18.459Z",
    fill: "#211242"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 18.459C56.2201 18.459 56.7705 17.9085 56.7705 17.2295C56.7705 16.5505 56.2201 16 55.541 16C54.862 16 54.3115 16.5505 54.3115 17.2295C54.3115 17.9085 54.862 18.459 55.541 18.459Z",
    fill: "#211242"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9834 18.459C59.6625 18.459 60.2129 17.9085 60.2129 17.2295C60.2129 16.5505 59.6625 16 58.9834 16C58.3044 16 57.7539 16.5505 57.7539 17.2295C57.7539 17.9085 58.3044 18.459 58.9834 18.459Z",
    fill: "#211242"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4258 18.459C63.1048 18.459 63.6553 17.9085 63.6553 17.2295C63.6553 16.5505 63.1048 16 62.4258 16C61.7468 16 61.1963 16.5505 61.1963 17.2295C61.1963 17.9085 61.7468 18.459 62.4258 18.459Z",
    fill: "#211242"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8692 18.459C66.5482 18.459 67.0987 17.9085 67.0987 17.2295C67.0987 16.5505 66.5482 16 65.8692 16C65.1901 16 64.6396 16.5505 64.6396 17.2295C64.6396 17.9085 65.1901 18.459 65.8692 18.459Z",
    fill: "#211242"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 66.6553C21.9085 66.6553 22.459 66.1048 22.459 65.4258C22.459 64.7468 21.9085 64.1963 21.2295 64.1963C20.5505 64.1963 20 64.7468 20 65.4258C20 66.1048 20.5505 66.6553 21.2295 66.6553Z",
    fill: "#A9E3FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 66.6563C59.7777 66.6563 60.3282 66.1058 60.3282 65.4268C60.3282 64.7477 59.7777 64.1973 59.0986 64.1973C58.4196 64.1973 57.8691 64.7477 57.8691 65.4268C57.8691 66.1058 58.4196 66.6563 59.0986 66.6563Z",
    fill: "#A9E3FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 63.2129C21.9085 63.2129 22.459 62.6625 22.459 61.9834C22.459 61.3044 21.9085 60.7539 21.2295 60.7539C20.5505 60.7539 20 61.3044 20 61.9834C20 62.6625 20.5505 63.2129 21.2295 63.2129Z",
    fill: "#A9E3FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 63.2129C59.7777 63.2129 60.3282 62.6625 60.3282 61.9834C60.3282 61.3044 59.7777 60.7539 59.0986 60.7539C58.4196 60.7539 57.8691 61.3044 57.8691 61.9834C57.8691 62.6625 58.4196 63.2129 59.0986 63.2129Z",
    fill: "#A9E3FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 70C21.9085 70 22.459 69.4496 22.459 68.7705C22.459 68.0915 21.9085 67.541 21.2295 67.541C20.5505 67.541 20 68.0915 20 68.7705C20 69.4496 20.5505 70 21.2295 70Z",
    fill: "#A9E3FF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 70C25.3509 70 25.9014 69.4496 25.9014 68.7705C25.9014 68.0915 25.3509 67.541 24.6719 67.541C23.9929 67.541 23.4424 68.0915 23.4424 68.7705C23.4424 69.4496 23.9929 70 24.6719 70Z",
    fill: "#A9E3FF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1143 70C28.7933 70 29.3438 69.4496 29.3438 68.7705C29.3438 68.0915 28.7933 67.541 28.1143 67.541C27.4352 67.541 26.8848 68.0915 26.8848 68.7705C26.8848 69.4496 27.4352 70 28.1143 70Z",
    fill: "#A9E3FF"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5576 70C32.2367 70 32.7871 69.4496 32.7871 68.7705C32.7871 68.0915 32.2367 67.541 31.5576 67.541C30.8786 67.541 30.3281 68.0915 30.3281 68.7705C30.3281 69.4496 30.8786 70 31.5576 70Z",
    fill: "#A9E3FF"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 70C35.6791 70 36.2295 69.4496 36.2295 68.7705C36.2295 68.0915 35.6791 67.541 35 67.541C34.321 67.541 33.7705 68.0915 33.7705 68.7705C33.7705 69.4496 34.321 70 35 70Z",
    fill: "#A9E3FF"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4424 70C39.1214 70 39.6719 69.4496 39.6719 68.7705C39.6719 68.0915 39.1214 67.541 38.4424 67.541C37.7634 67.541 37.2129 68.0915 37.2129 68.7705C37.2129 69.4496 37.7634 70 38.4424 70Z",
    fill: "#A9E3FF"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8848 70C42.5638 70 43.1143 69.4496 43.1143 68.7705C43.1143 68.0915 42.5638 67.541 41.8848 67.541C41.2057 67.541 40.6553 68.0915 40.6553 68.7705C40.6553 69.4496 41.2057 70 41.8848 70Z",
    fill: "#A9E3FF"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3281 70C46.0072 70 46.5576 69.4496 46.5576 68.7705C46.5576 68.0915 46.0072 67.541 45.3281 67.541C44.6491 67.541 44.0986 68.0915 44.0986 68.7705C44.0986 69.4496 44.6491 70 45.3281 70Z",
    fill: "#A9E3FF"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7705 70C49.4496 70 50 69.4496 50 68.7705C50 68.0915 49.4496 67.541 48.7705 67.541C48.0915 67.541 47.541 68.0915 47.541 68.7705C47.541 69.4496 48.0915 70 48.7705 70Z",
    fill: "#A9E3FF"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2129 70C52.8919 70 53.4424 69.4496 53.4424 68.7705C53.4424 68.0915 52.8919 67.541 52.2129 67.541C51.5339 67.541 50.9834 68.0915 50.9834 68.7705C50.9834 69.4496 51.5339 70 52.2129 70Z",
    fill: "#A9E3FF"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 70C56.3343 70 56.8848 69.4496 56.8848 68.7705C56.8848 68.0915 56.3343 67.541 55.6553 67.541C54.9763 67.541 54.4258 68.0915 54.4258 68.7705C54.4258 69.4496 54.9763 70 55.6553 70Z",
    fill: "#A9E3FF"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 66.6553C25.3509 66.6553 25.9014 66.1048 25.9014 65.4258C25.9014 64.7468 25.3509 64.1963 24.6719 64.1963C23.9929 64.1963 23.4424 64.7468 23.4424 65.4258C23.4424 66.1048 23.9929 66.6553 24.6719 66.6553Z",
    fill: "#A9E3FF"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1143 66.6563C28.7933 66.6563 29.3438 66.1058 29.3438 65.4268C29.3438 64.7477 28.7933 64.1973 28.1143 64.1973C27.4352 64.1973 26.8848 64.7477 26.8848 65.4268C26.8848 66.1058 27.4352 66.6563 28.1143 66.6563Z",
    fill: "#A9E3FF"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5576 66.6563C32.2367 66.6563 32.7871 66.1058 32.7871 65.4268C32.7871 64.7477 32.2367 64.1973 31.5576 64.1973C30.8786 64.1973 30.3281 64.7477 30.3281 65.4268C30.3281 66.1058 30.8786 66.6563 31.5576 66.6563Z",
    fill: "#A9E3FF"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 66.6553C35.6791 66.6553 36.2295 66.1048 36.2295 65.4258C36.2295 64.7468 35.6791 64.1963 35 64.1963C34.321 64.1963 33.7705 64.7468 33.7705 65.4258C33.7705 66.1048 34.321 66.6553 35 66.6553Z",
    fill: "#A9E3FF"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4424 66.6553C39.1214 66.6553 39.6719 66.1048 39.6719 65.4258C39.6719 64.7468 39.1214 64.1963 38.4424 64.1963C37.7634 64.1963 37.2129 64.7468 37.2129 65.4258C37.2129 66.1048 37.7634 66.6553 38.4424 66.6553Z",
    fill: "#A9E3FF"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8848 66.6563C42.5638 66.6563 43.1143 66.1058 43.1143 65.4268C43.1143 64.7477 42.5638 64.1973 41.8848 64.1973C41.2057 64.1973 40.6553 64.7477 40.6553 65.4268C40.6553 66.1058 41.2057 66.6563 41.8848 66.6563Z",
    fill: "#A9E3FF"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3281 66.6563C46.0072 66.6563 46.5576 66.1058 46.5576 65.4268C46.5576 64.7477 46.0072 64.1973 45.3281 64.1973C44.6491 64.1973 44.0986 64.7477 44.0986 65.4268C44.0986 66.1058 44.6491 66.6563 45.3281 66.6563Z",
    fill: "#A9E3FF"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7705 66.6553C49.4496 66.6553 50 66.1048 50 65.4258C50 64.7468 49.4496 64.1963 48.7705 64.1963C48.0915 64.1963 47.541 64.7468 47.541 65.4258C47.541 66.1048 48.0915 66.6553 48.7705 66.6553Z",
    fill: "#A9E3FF"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2129 66.6553C52.8919 66.6553 53.4424 66.1048 53.4424 65.4258C53.4424 64.7468 52.8919 64.1963 52.2129 64.1963C51.5339 64.1963 50.9834 64.7468 50.9834 65.4258C50.9834 66.1048 51.5339 66.6553 52.2129 66.6553Z",
    fill: "#A9E3FF"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 66.6563C56.3343 66.6563 56.8848 66.1058 56.8848 65.4268C56.8848 64.7477 56.3343 64.1973 55.6553 64.1973C54.9763 64.1973 54.4258 64.7477 54.4258 65.4268C54.4258 66.1058 54.9763 66.6563 55.6553 66.6563Z",
    fill: "#A9E3FF"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 70C59.7777 70 60.3282 69.4496 60.3282 68.7705C60.3282 68.0915 59.7777 67.541 59.0986 67.541C58.4196 67.541 57.8691 68.0915 57.8691 68.7705C57.8691 69.4496 58.4196 70 59.0986 70Z",
    fill: "#A9E3FF"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 59.7705C21.9085 59.7705 22.459 59.2201 22.459 58.541C22.459 57.862 21.9085 57.3115 21.2295 57.3115C20.5505 57.3115 20 57.862 20 58.541C20 59.2201 20.5505 59.7705 21.2295 59.7705Z",
    fill: "#A9E3FF"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 59.7705C59.7777 59.7705 60.3282 59.2201 60.3282 58.541C60.3282 57.862 59.7777 57.3115 59.0986 57.3115C58.4196 57.3115 57.8691 57.862 57.8691 58.541C57.8691 59.2201 58.4196 59.7705 59.0986 59.7705Z",
    fill: "#A9E3FF"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 56.3282C21.9085 56.3282 22.459 55.7777 22.459 55.0986C22.459 54.4196 21.9085 53.8691 21.2295 53.8691C20.5505 53.8691 20 54.4196 20 55.0986C20 55.7777 20.5505 56.3282 21.2295 56.3282Z",
    fill: "#A9E3FF"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 56.3282C59.7777 56.3282 60.3282 55.7777 60.3282 55.0986C60.3282 54.4196 59.7777 53.8691 59.0986 53.8691C58.4196 53.8691 57.8691 54.4196 57.8691 55.0986C57.8691 55.7777 58.4196 56.3282 59.0986 56.3282Z",
    fill: "#A9E3FF"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 52.8848C21.9085 52.8848 22.459 52.3343 22.459 51.6553C22.459 50.9763 21.9085 50.4258 21.2295 50.4258C20.5505 50.4258 20 50.9763 20 51.6553C20 52.3343 20.5505 52.8848 21.2295 52.8848Z",
    fill: "#A9E3FF"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 52.8848C59.7777 52.8848 60.3282 52.3343 60.3282 51.6553C60.3282 50.9763 59.7777 50.4258 59.0986 50.4258C58.4196 50.4258 57.8691 50.9763 57.8691 51.6553C57.8691 52.3343 58.4196 52.8848 59.0986 52.8848Z",
    fill: "#A9E3FF"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 49.4424C21.9085 49.4424 22.459 48.8919 22.459 48.2129C22.459 47.5339 21.9085 46.9834 21.2295 46.9834C20.5505 46.9834 20 47.5339 20 48.2129C20 48.8919 20.5505 49.4424 21.2295 49.4424Z",
    fill: "#A9E3FF"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 49.4424C59.7777 49.4424 60.3282 48.8919 60.3282 48.2129C60.3282 47.5339 59.7777 46.9834 59.0986 46.9834C58.4196 46.9834 57.8691 47.5339 57.8691 48.2129C57.8691 48.8919 58.4196 49.4424 59.0986 49.4424Z",
    fill: "#A9E3FF"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 46C21.9085 46 22.459 45.4496 22.459 44.7705C22.459 44.0915 21.9085 43.541 21.2295 43.541C20.5505 43.541 20 44.0915 20 44.7705C20 45.4496 20.5505 46 21.2295 46Z",
    fill: "#A9E3FF"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 46C59.7777 46 60.3282 45.4496 60.3282 44.7705C60.3282 44.0915 59.7777 43.541 59.0986 43.541C58.4196 43.541 57.8691 44.0915 57.8691 44.7705C57.8691 45.4496 58.4196 46 59.0986 46Z",
    fill: "#A9E3FF"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 42.5576C21.9085 42.5576 22.459 42.0072 22.459 41.3281C22.459 40.6491 21.9085 40.0986 21.2295 40.0986C20.5505 40.0986 20 40.6491 20 41.3281C20 42.0072 20.5505 42.5576 21.2295 42.5576Z",
    fill: "#A9E3FF"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 42.5576C59.7777 42.5576 60.3282 42.0072 60.3282 41.3281C60.3282 40.6491 59.7777 40.0986 59.0986 40.0986C58.4196 40.0986 57.8691 40.6491 57.8691 41.3281C57.8691 42.0072 58.4196 42.5576 59.0986 42.5576Z",
    fill: "#A9E3FF"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 39.1143C21.9085 39.1143 22.459 38.5638 22.459 37.8848C22.459 37.2057 21.9085 36.6553 21.2295 36.6553C20.5505 36.6553 20 37.2057 20 37.8848C20 38.5638 20.5505 39.1143 21.2295 39.1143Z",
    fill: "#A9E3FF"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 39.1153C59.7777 39.1153 60.3282 38.5648 60.3282 37.8858C60.3282 37.2067 59.7777 36.6562 59.0986 36.6562C58.4196 36.6562 57.8691 37.2067 57.8691 37.8858C57.8691 38.5648 58.4196 39.1153 59.0986 39.1153Z",
    fill: "#A9E3FF"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 35.6719C21.9085 35.6719 22.459 35.1214 22.459 34.4424C22.459 33.7634 21.9085 33.2129 21.2295 33.2129C20.5505 33.2129 20 33.7634 20 34.4424C20 35.1214 20.5505 35.6719 21.2295 35.6719Z",
    fill: "#A9E3FF"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 35.6719C59.7777 35.6719 60.3282 35.1214 60.3282 34.4424C60.3282 33.7634 59.7777 33.2129 59.0986 33.2129C58.4196 33.2129 57.8691 33.7634 57.8691 34.4424C57.8691 35.1214 58.4196 35.6719 59.0986 35.6719Z",
    fill: "#A9E3FF"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 32.2295C21.9085 32.2295 22.459 31.6791 22.459 31C22.459 30.321 21.9085 29.7705 21.2295 29.7705C20.5505 29.7705 20 30.321 20 31C20 31.6791 20.5505 32.2295 21.2295 32.2295Z",
    fill: "#A9E3FF"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 32.2295C59.7777 32.2295 60.3282 31.6791 60.3282 31C60.3282 30.321 59.7777 29.7705 59.0986 29.7705C58.4196 29.7705 57.8691 30.321 57.8691 31C57.8691 31.6791 58.4196 32.2295 59.0986 32.2295Z",
    fill: "#A9E3FF"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 28.7871C21.9085 28.7871 22.459 28.2367 22.459 27.5576C22.459 26.8786 21.9085 26.3281 21.2295 26.3281C20.5505 26.3281 20 26.8786 20 27.5576C20 28.2367 20.5505 28.7871 21.2295 28.7871Z",
    fill: "#A9E3FF"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 28.7871C35.6791 28.7871 36.2295 28.2367 36.2295 27.5576C36.2295 26.8786 35.6791 26.3281 35 26.3281C34.321 26.3281 33.7705 26.8786 33.7705 27.5576C33.7705 28.2367 34.321 28.7871 35 28.7871Z",
    fill: "#A9E3FF"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4424 28.7871C39.1214 28.7871 39.6719 28.2367 39.6719 27.5576C39.6719 26.8786 39.1214 26.3281 38.4424 26.3281C37.7634 26.3281 37.2129 26.8786 37.2129 27.5576C37.2129 28.2367 37.7634 28.7871 38.4424 28.7871Z",
    fill: "#A9E3FF"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8848 28.7871C42.5638 28.7871 43.1143 28.2367 43.1143 27.5576C43.1143 26.8786 42.5638 26.3281 41.8848 26.3281C41.2057 26.3281 40.6553 26.8786 40.6553 27.5576C40.6553 28.2367 41.2057 28.7871 41.8848 28.7871Z",
    fill: "#A9E3FF"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3281 28.7871C46.0072 28.7871 46.5576 28.2367 46.5576 27.5576C46.5576 26.8786 46.0072 26.3281 45.3281 26.3281C44.6491 26.3281 44.0986 26.8786 44.0986 27.5576C44.0986 28.2367 44.6491 28.7871 45.3281 28.7871Z",
    fill: "#A9E3FF"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter49_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5576 35.6719C32.2367 35.6719 32.7871 35.1214 32.7871 34.4424C32.7871 33.7634 32.2367 33.2129 31.5576 33.2129C30.8786 33.2129 30.3281 33.7634 30.3281 34.4424C30.3281 35.1214 30.8786 35.6719 31.5576 35.6719Z",
    fill: "#A9E3FF"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter50_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 35.6719C35.6791 35.6719 36.2295 35.1214 36.2295 34.4424C36.2295 33.7634 35.6791 33.2129 35 33.2129C34.321 33.2129 33.7705 33.7634 33.7705 34.4424C33.7705 35.1214 34.321 35.6719 35 35.6719Z",
    fill: "#A9E3FF"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4424 35.6719C39.1214 35.6719 39.6719 35.1214 39.6719 34.4424C39.6719 33.7634 39.1214 33.2129 38.4424 33.2129C37.7634 33.2129 37.2129 33.7634 37.2129 34.4424C37.2129 35.1214 37.7634 35.6719 38.4424 35.6719Z",
    fill: "#A9E3FF"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter52_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8848 35.6719C42.5638 35.6719 43.1143 35.1214 43.1143 34.4424C43.1143 33.7634 42.5638 33.2129 41.8848 33.2129C41.2057 33.2129 40.6553 33.7634 40.6553 34.4424C40.6553 35.1214 41.2057 35.6719 41.8848 35.6719Z",
    fill: "#A9E3FF"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter53_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3281 35.6719C46.0072 35.6719 46.5576 35.1214 46.5576 34.4424C46.5576 33.7634 46.0072 33.2129 45.3281 33.2129C44.6491 33.2129 44.0986 33.7634 44.0986 34.4424C44.0986 35.1214 44.6491 35.6719 45.3281 35.6719Z",
    fill: "#A9E3FF"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter54_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7705 35.6719C49.4496 35.6719 50 35.1214 50 34.4424C50 33.7634 49.4496 33.2129 48.7705 33.2129C48.0915 33.2129 47.541 33.7634 47.541 34.4424C47.541 35.1214 48.0915 35.6719 48.7705 35.6719Z",
    fill: "#A9E3FF"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter55_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 28.7871C59.7777 28.7871 60.3282 28.2367 60.3282 27.5576C60.3282 26.8786 59.7777 26.3281 59.0986 26.3281C58.4196 26.3281 57.8691 26.8786 57.8691 27.5576C57.8691 28.2367 58.4196 28.7871 59.0986 28.7871Z",
    fill: "#A9E3FF"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 25.3438C21.9085 25.3438 22.459 24.7933 22.459 24.1143C22.459 23.4352 21.9085 22.8848 21.2295 22.8848C20.5505 22.8848 20 23.4352 20 24.1143C20 24.7933 20.5505 25.3438 21.2295 25.3438Z",
    fill: "#A9E3FF"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter57_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 63.2129C25.3509 63.2129 25.9014 62.6625 25.9014 61.9834C25.9014 61.3044 25.3509 60.7539 24.6719 60.7539C23.9929 60.7539 23.4424 61.3044 23.4424 61.9834C23.4424 62.6625 23.9929 63.2129 24.6719 63.2129Z",
    fill: "#A9E3FF"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter58_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 59.7705C25.3509 59.7705 25.9014 59.2201 25.9014 58.541C25.9014 57.862 25.3509 57.3115 24.6719 57.3115C23.9929 57.3115 23.4424 57.862 23.4424 58.541C23.4424 59.2201 23.9929 59.7705 24.6719 59.7705Z",
    fill: "#A9E3FF"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter59_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 56.3282C25.3509 56.3282 25.9014 55.7777 25.9014 55.0986C25.9014 54.4196 25.3509 53.8691 24.6719 53.8691C23.9929 53.8691 23.4424 54.4196 23.4424 55.0986C23.4424 55.7777 23.9929 56.3282 24.6719 56.3282Z",
    fill: "#A9E3FF"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter60_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 52.8848C25.3509 52.8848 25.9014 52.3343 25.9014 51.6553C25.9014 50.9763 25.3509 50.4258 24.6719 50.4258C23.9929 50.4258 23.4424 50.9763 23.4424 51.6553C23.4424 52.3343 23.9929 52.8848 24.6719 52.8848Z",
    fill: "#A9E3FF"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter61_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 49.4424C25.3509 49.4424 25.9014 48.8919 25.9014 48.2129C25.9014 47.5339 25.3509 46.9834 24.6719 46.9834C23.9929 46.9834 23.4424 47.5339 23.4424 48.2129C23.4424 48.8919 23.9929 49.4424 24.6719 49.4424Z",
    fill: "#A9E3FF"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter62_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 46C25.3509 46 25.9014 45.4496 25.9014 44.7705C25.9014 44.0915 25.3509 43.541 24.6719 43.541C23.9929 43.541 23.4424 44.0915 23.4424 44.7705C23.4424 45.4496 23.9929 46 24.6719 46Z",
    fill: "#A9E3FF"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter63_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 42.5576C25.3509 42.5576 25.9014 42.0072 25.9014 41.3281C25.9014 40.6491 25.3509 40.0986 24.6719 40.0986C23.9929 40.0986 23.4424 40.6491 23.4424 41.3281C23.4424 42.0072 23.9929 42.5576 24.6719 42.5576Z",
    fill: "#A9E3FF"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter64_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 39.1143C25.3509 39.1143 25.9014 38.5638 25.9014 37.8848C25.9014 37.2057 25.3509 36.6553 24.6719 36.6553C23.9929 36.6553 23.4424 37.2057 23.4424 37.8848C23.4424 38.5638 23.9929 39.1143 24.6719 39.1143Z",
    fill: "#A9E3FF"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter65_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 35.6719C25.3509 35.6719 25.9014 35.1214 25.9014 34.4424C25.9014 33.7634 25.3509 33.2129 24.6719 33.2129C23.9929 33.2129 23.4424 33.7634 23.4424 34.4424C23.4424 35.1214 23.9929 35.6719 24.6719 35.6719Z",
    fill: "#A9E3FF"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter66_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 32.2295C25.3509 32.2295 25.9014 31.6791 25.9014 31C25.9014 30.321 25.3509 29.7705 24.6719 29.7705C23.9929 29.7705 23.4424 30.321 23.4424 31C23.4424 31.6791 23.9929 32.2295 24.6719 32.2295Z",
    fill: "#A9E3FF"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter67_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 28.7871C25.3509 28.7871 25.9014 28.2367 25.9014 27.5576C25.9014 26.8786 25.3509 26.3281 24.6719 26.3281C23.9929 26.3281 23.4424 26.8786 23.4424 27.5576C23.4424 28.2367 23.9929 28.7871 24.6719 28.7871Z",
    fill: "#A9E3FF"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter68_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 25.3438C25.3509 25.3438 25.9014 24.7933 25.9014 24.1143C25.9014 23.4352 25.3509 22.8848 24.6719 22.8848C23.9929 22.8848 23.4424 23.4352 23.4424 24.1143C23.4424 24.7933 23.9929 25.3438 24.6719 25.3438Z",
    fill: "#A9E3FF"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter69_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 25.3438C59.7777 25.3438 60.3282 24.7933 60.3282 24.1143C60.3282 23.4352 59.7777 22.8848 59.0986 22.8848C58.4196 22.8848 57.8691 23.4352 57.8691 24.1143C57.8691 24.7933 58.4196 25.3438 59.0986 25.3438Z",
    fill: "#A9E3FF"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter70_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 63.2129C56.3343 63.2129 56.8848 62.6625 56.8848 61.9834C56.8848 61.3044 56.3343 60.7539 55.6553 60.7539C54.9763 60.7539 54.4258 61.3044 54.4258 61.9834C54.4258 62.6625 54.9763 63.2129 55.6553 63.2129Z",
    fill: "#A9E3FF"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter71_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 59.7705C56.3343 59.7705 56.8848 59.2201 56.8848 58.541C56.8848 57.862 56.3343 57.3115 55.6553 57.3115C54.9763 57.3115 54.4258 57.862 54.4258 58.541C54.4258 59.2201 54.9763 59.7705 55.6553 59.7705Z",
    fill: "#A9E3FF"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter72_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 56.3282C56.3343 56.3282 56.8848 55.7777 56.8848 55.0986C56.8848 54.4196 56.3343 53.8691 55.6553 53.8691C54.9763 53.8691 54.4258 54.4196 54.4258 55.0986C54.4258 55.7777 54.9763 56.3282 55.6553 56.3282Z",
    fill: "#A9E3FF"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter73_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 52.8848C56.3343 52.8848 56.8848 52.3343 56.8848 51.6553C56.8848 50.9763 56.3343 50.4258 55.6553 50.4258C54.9763 50.4258 54.4258 50.9763 54.4258 51.6553C54.4258 52.3343 54.9763 52.8848 55.6553 52.8848Z",
    fill: "#A9E3FF"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter74_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 49.4424C56.3343 49.4424 56.8848 48.8919 56.8848 48.2129C56.8848 47.5339 56.3343 46.9834 55.6553 46.9834C54.9763 46.9834 54.4258 47.5339 54.4258 48.2129C54.4258 48.8919 54.9763 49.4424 55.6553 49.4424Z",
    fill: "#A9E3FF"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter75_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 46C56.3343 46 56.8848 45.4496 56.8848 44.7705C56.8848 44.0915 56.3343 43.541 55.6553 43.541C54.9763 43.541 54.4258 44.0915 54.4258 44.7705C54.4258 45.4496 54.9763 46 55.6553 46Z",
    fill: "#A9E3FF"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter76_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 42.5576C56.3343 42.5576 56.8848 42.0072 56.8848 41.3281C56.8848 40.6491 56.3343 40.0986 55.6553 40.0986C54.9763 40.0986 54.4258 40.6491 54.4258 41.3281C54.4258 42.0072 54.9763 42.5576 55.6553 42.5576Z",
    fill: "#A9E3FF"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter77_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 39.1153C56.3343 39.1153 56.8848 38.5648 56.8848 37.8858C56.8848 37.2067 56.3343 36.6562 55.6553 36.6562C54.9763 36.6562 54.4258 37.2067 54.4258 37.8858C54.4258 38.5648 54.9763 39.1153 55.6553 39.1153Z",
    fill: "#A9E3FF"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter78_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 35.6719C56.3343 35.6719 56.8848 35.1214 56.8848 34.4424C56.8848 33.7634 56.3343 33.2129 55.6553 33.2129C54.9763 33.2129 54.4258 33.7634 54.4258 34.4424C54.4258 35.1214 54.9763 35.6719 55.6553 35.6719Z",
    fill: "#A9E3FF"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter79_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 32.2295C56.3343 32.2295 56.8848 31.6791 56.8848 31C56.8848 30.321 56.3343 29.7705 55.6553 29.7705C54.9763 29.7705 54.4258 30.321 54.4258 31C54.4258 31.6791 54.9763 32.2295 55.6553 32.2295Z",
    fill: "#A9E3FF"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter80_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 28.7871C56.3343 28.7871 56.8848 28.2367 56.8848 27.5576C56.8848 26.8786 56.3343 26.3281 55.6553 26.3281C54.9763 26.3281 54.4258 26.8786 54.4258 27.5576C54.4258 28.2367 54.9763 28.7871 55.6553 28.7871Z",
    fill: "#A9E3FF"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter81_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 25.3438C56.3343 25.3438 56.8848 24.7933 56.8848 24.1143C56.8848 23.4352 56.3343 22.8848 55.6553 22.8848C54.9763 22.8848 54.4258 23.4352 54.4258 24.1143C54.4258 24.7933 54.9763 25.3438 55.6553 25.3438Z",
    fill: "#A9E3FF"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter82_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 21.9014C21.9085 21.9014 22.459 21.3509 22.459 20.6719C22.459 19.9929 21.9085 19.4424 21.2295 19.4424C20.5505 19.4424 20 19.9929 20 20.6719C20 21.3509 20.5505 21.9014 21.2295 21.9014Z",
    fill: "#A9E3FF"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter83_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 21.9014C59.7777 21.9014 60.3282 21.3509 60.3282 20.6719C60.3282 19.9929 59.7777 19.4424 59.0986 19.4424C58.4196 19.4424 57.8691 19.9929 57.8691 20.6719C57.8691 21.3509 58.4196 21.9014 59.0986 21.9014Z",
    fill: "#A9E3FF"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter84_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 18.459C21.9085 18.459 22.459 17.9085 22.459 17.2295C22.459 16.5505 21.9085 16 21.2295 16C20.5505 16 20 16.5505 20 17.2295C20 17.9085 20.5505 18.459 21.2295 18.459Z",
    fill: "#A9E3FF"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter85_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 18.459C25.3509 18.459 25.9014 17.9085 25.9014 17.2295C25.9014 16.5505 25.3509 16 24.6719 16C23.9929 16 23.4424 16.5505 23.4424 17.2295C23.4424 17.9085 23.9929 18.459 24.6719 18.459Z",
    fill: "#A9E3FF"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter86_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1143 18.459C28.7933 18.459 29.3438 17.9085 29.3438 17.2295C29.3438 16.5505 28.7933 16 28.1143 16C27.4352 16 26.8848 16.5505 26.8848 17.2295C26.8848 17.9085 27.4352 18.459 28.1143 18.459Z",
    fill: "#A9E3FF"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter87_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5576 18.459C32.2367 18.459 32.7871 17.9085 32.7871 17.2295C32.7871 16.5505 32.2367 16 31.5576 16C30.8786 16 30.3281 16.5505 30.3281 17.2295C30.3281 17.9085 30.8786 18.459 31.5576 18.459Z",
    fill: "#A9E3FF"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter88_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 18.459C35.6791 18.459 36.2295 17.9085 36.2295 17.2295C36.2295 16.5505 35.6791 16 35 16C34.321 16 33.7705 16.5505 33.7705 17.2295C33.7705 17.9085 34.321 18.459 35 18.459Z",
    fill: "#A9E3FF"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter89_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4424 18.459C39.1214 18.459 39.6719 17.9085 39.6719 17.2295C39.6719 16.5505 39.1214 16 38.4424 16C37.7634 16 37.2129 16.5505 37.2129 17.2295C37.2129 17.9085 37.7634 18.459 38.4424 18.459Z",
    fill: "#A9E3FF"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter90_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8848 18.459C42.5638 18.459 43.1143 17.9085 43.1143 17.2295C43.1143 16.5505 42.5638 16 41.8848 16C41.2057 16 40.6553 16.5505 40.6553 17.2295C40.6553 17.9085 41.2057 18.459 41.8848 18.459Z",
    fill: "#A9E3FF"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter91_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3281 18.459C46.0072 18.459 46.5576 17.9085 46.5576 17.2295C46.5576 16.5505 46.0072 16 45.3281 16C44.6491 16 44.0986 16.5505 44.0986 17.2295C44.0986 17.9085 44.6491 18.459 45.3281 18.459Z",
    fill: "#A9E3FF"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter92_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7705 18.459C49.4496 18.459 50 17.9085 50 17.2295C50 16.5505 49.4496 16 48.7705 16C48.0915 16 47.541 16.5505 47.541 17.2295C47.541 17.9085 48.0915 18.459 48.7705 18.459Z",
    fill: "#A9E3FF"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter93_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2129 18.459C52.8919 18.459 53.4424 17.9085 53.4424 17.2295C53.4424 16.5505 52.8919 16 52.2129 16C51.5339 16 50.9834 16.5505 50.9834 17.2295C50.9834 17.9085 51.5339 18.459 52.2129 18.459Z",
    fill: "#A9E3FF"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter94_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 18.459C56.3343 18.459 56.8848 17.9085 56.8848 17.2295C56.8848 16.5505 56.3343 16 55.6553 16C54.9763 16 54.4258 16.5505 54.4258 17.2295C54.4258 17.9085 54.9763 18.459 55.6553 18.459Z",
    fill: "#A9E3FF"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter95_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 21.9014C25.3509 21.9014 25.9014 21.3509 25.9014 20.6719C25.9014 19.9929 25.3509 19.4424 24.6719 19.4424C23.9929 19.4424 23.4424 19.9929 23.4424 20.6719C23.4424 21.3509 23.9929 21.9014 24.6719 21.9014Z",
    fill: "#A9E3FF"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter96_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1143 21.9014C28.7933 21.9014 29.3438 21.3509 29.3438 20.6719C29.3438 19.9929 28.7933 19.4424 28.1143 19.4424C27.4352 19.4424 26.8848 19.9929 26.8848 20.6719C26.8848 21.3509 27.4352 21.9014 28.1143 21.9014Z",
    fill: "#A9E3FF"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter97_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5576 21.9014C32.2367 21.9014 32.7871 21.3509 32.7871 20.6719C32.7871 19.9929 32.2367 19.4424 31.5576 19.4424C30.8786 19.4424 30.3281 19.9929 30.3281 20.6719C30.3281 21.3509 30.8786 21.9014 31.5576 21.9014Z",
    fill: "#A9E3FF"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter98_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 21.9014C35.6791 21.9014 36.2295 21.3509 36.2295 20.6719C36.2295 19.9929 35.6791 19.4424 35 19.4424C34.321 19.4424 33.7705 19.9929 33.7705 20.6719C33.7705 21.3509 34.321 21.9014 35 21.9014Z",
    fill: "#A9E3FF"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter99_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4424 21.9014C39.1214 21.9014 39.6719 21.3509 39.6719 20.6719C39.6719 19.9929 39.1214 19.4424 38.4424 19.4424C37.7634 19.4424 37.2129 19.9929 37.2129 20.6719C37.2129 21.3509 37.7634 21.9014 38.4424 21.9014Z",
    fill: "#A9E3FF"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter100_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8848 21.9014C42.5638 21.9014 43.1143 21.3509 43.1143 20.6719C43.1143 19.9929 42.5638 19.4424 41.8848 19.4424C41.2057 19.4424 40.6553 19.9929 40.6553 20.6719C40.6553 21.3509 41.2057 21.9014 41.8848 21.9014Z",
    fill: "#A9E3FF"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter101_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3281 21.9014C46.0072 21.9014 46.5576 21.3509 46.5576 20.6719C46.5576 19.9929 46.0072 19.4424 45.3281 19.4424C44.6491 19.4424 44.0986 19.9929 44.0986 20.6719C44.0986 21.3509 44.6491 21.9014 45.3281 21.9014Z",
    fill: "#A9E3FF"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter102_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7705 21.9014C49.4496 21.9014 50 21.3509 50 20.6719C50 19.9929 49.4496 19.4424 48.7705 19.4424C48.0915 19.4424 47.541 19.9929 47.541 20.6719C47.541 21.3509 48.0915 21.9014 48.7705 21.9014Z",
    fill: "#A9E3FF"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter103_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2129 21.9014C52.8919 21.9014 53.4424 21.3509 53.4424 20.6719C53.4424 19.9929 52.8919 19.4424 52.2129 19.4424C51.5339 19.4424 50.9834 19.9929 50.9834 20.6719C50.9834 21.3509 51.5339 21.9014 52.2129 21.9014Z",
    fill: "#A9E3FF"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter104_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6553 21.9014C56.3343 21.9014 56.8848 21.3509 56.8848 20.6719C56.8848 19.9929 56.3343 19.4424 55.6553 19.4424C54.9763 19.4424 54.4258 19.9929 54.4258 20.6719C54.4258 21.3509 54.9763 21.9014 55.6553 21.9014Z",
    fill: "#A9E3FF"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter105_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0986 18.459C59.7777 18.459 60.3282 17.9085 60.3282 17.2295C60.3282 16.5505 59.7777 16 59.0986 16C58.4196 16 57.8691 16.5505 57.8691 17.2295C57.8691 17.9085 58.4196 18.459 59.0986 18.459Z",
    fill: "#A9E3FF"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter106_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4424 56.3282C39.1214 56.3282 39.6719 55.7777 39.6719 55.0986C39.6719 54.4196 39.1214 53.8691 38.4424 53.8691C37.7634 53.8691 37.2129 54.4196 37.2129 55.0986C37.2129 55.7777 37.7634 56.3282 38.4424 56.3282Z",
    fill: "#FF2F57"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter107_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8848 56.3282C42.5638 56.3282 43.1143 55.7777 43.1143 55.0986C43.1143 54.4196 42.5638 53.8691 41.8848 53.8691C41.2057 53.8691 40.6553 54.4196 40.6553 55.0986C40.6553 55.7777 41.2057 56.3282 41.8848 56.3282Z",
    fill: "#FF2F57"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter108_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4424 46C39.1214 46 39.6719 45.4496 39.6719 44.7705C39.6719 44.0915 39.1214 43.541 38.4424 43.541C37.7634 43.541 37.2129 44.0915 37.2129 44.7705C37.2129 45.4496 37.7634 46 38.4424 46Z",
    fill: "#FF2F57"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter109_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8848 46C42.5638 46 43.1143 45.4496 43.1143 44.7705C43.1143 44.0915 42.5638 43.541 41.8848 43.541C41.2057 43.541 40.6553 44.0915 40.6553 44.7705C40.6553 45.4496 41.2057 46 41.8848 46Z",
    fill: "#FF2F57"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter110_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 59.7705C35.6791 59.7705 36.2295 59.2201 36.2295 58.541C36.2295 57.862 35.6791 57.3115 35 57.3115C34.321 57.3115 33.7705 57.862 33.7705 58.541C33.7705 59.2201 34.321 59.7705 35 59.7705Z",
    fill: "#FF2F57"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter111_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3281 59.7705C46.0072 59.7705 46.5576 59.2201 46.5576 58.541C46.5576 57.862 46.0072 57.3115 45.3281 57.3115C44.6491 57.3115 44.0986 57.862 44.0986 58.541C44.0986 59.2201 44.6491 59.7705 45.3281 59.7705Z",
    fill: "#FF2F57"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter112_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 52.8848C35.6791 52.8848 36.2295 52.3343 36.2295 51.6553C36.2295 50.9763 35.6791 50.4258 35 50.4258C34.321 50.4258 33.7705 50.9763 33.7705 51.6553C33.7705 52.3343 34.321 52.8848 35 52.8848Z",
    fill: "#FF2F57"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter113_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4424 52.8848C39.1214 52.8848 39.6719 52.3343 39.6719 51.6553C39.6719 50.9763 39.1214 50.4258 38.4424 50.4258C37.7634 50.4258 37.2129 50.9763 37.2129 51.6553C37.2129 52.3343 37.7634 52.8848 38.4424 52.8848Z",
    fill: "#FF2F57"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter114_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8848 52.8848C42.5638 52.8848 43.1143 52.3343 43.1143 51.6553C43.1143 50.9763 42.5638 50.4258 41.8848 50.4258C41.2057 50.4258 40.6553 50.9763 40.6553 51.6553C40.6553 52.3343 41.2057 52.8848 41.8848 52.8848Z",
    fill: "#FF2F57"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter115_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3281 52.8848C46.0072 52.8848 46.5576 52.3343 46.5576 51.6553C46.5576 50.9763 46.0072 50.4258 45.3281 50.4258C44.6491 50.4258 44.0986 50.9763 44.0986 51.6553C44.0986 52.3343 44.6491 52.8848 45.3281 52.8848Z",
    fill: "#FF2F57"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter116_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 49.4424C35.6791 49.4424 36.2295 48.8919 36.2295 48.2129C36.2295 47.5339 35.6791 46.9834 35 46.9834C34.321 46.9834 33.7705 47.5339 33.7705 48.2129C33.7705 48.8919 34.321 49.4424 35 49.4424Z",
    fill: "#FF2F57"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter117_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4424 49.4424C39.1214 49.4424 39.6719 48.8919 39.6719 48.2129C39.6719 47.5339 39.1214 46.9834 38.4424 46.9834C37.7634 46.9834 37.2129 47.5339 37.2129 48.2129C37.2129 48.8919 37.7634 49.4424 38.4424 49.4424Z",
    fill: "#FF2F57"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter118_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8848 49.4424C42.5638 49.4424 43.1143 48.8919 43.1143 48.2129C43.1143 47.5339 42.5638 46.9834 41.8848 46.9834C41.2057 46.9834 40.6553 47.5339 40.6553 48.2129C40.6553 48.8919 41.2057 49.4424 41.8848 49.4424Z",
    fill: "#FF2F57"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter119_di_2079_3180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3281 49.4424C46.0072 49.4424 46.5576 48.8919 46.5576 48.2129C46.5576 47.5339 46.0072 46.9834 45.3281 46.9834C44.6491 46.9834 44.0986 47.5339 44.0986 48.2129C44.0986 48.8919 44.6491 49.4424 45.3281 49.4424Z",
    fill: "#FF2F57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2079_3180",
    x: 0,
    y: 48.1963,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_2079_3180",
    x: 37.8691,
    y: 48.1973,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_2079_3180",
    x: 0,
    y: 44.7539,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_2079_3180",
    x: 37.8691,
    y: 44.7539,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_2079_3180",
    x: 0,
    y: 51.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_di_2079_3180",
    x: 3.4424,
    y: 51.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_di_2079_3180",
    x: 6.8848,
    y: 51.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_di_2079_3180",
    x: 10.3281,
    y: 51.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_di_2079_3180",
    x: 13.7705,
    y: 51.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_di_2079_3180",
    x: 17.2129,
    y: 51.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_di_2079_3180",
    x: 20.6553,
    y: 51.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_di_2079_3180",
    x: 24.0986,
    y: 51.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_di_2079_3180",
    x: 27.541,
    y: 51.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_di_2079_3180",
    x: 30.9834,
    y: 51.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_di_2079_3180",
    x: 34.4258,
    y: 51.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_di_2079_3180",
    x: 3.4424,
    y: 48.1963,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_di_2079_3180",
    x: 6.8848,
    y: 48.1973,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_di_2079_3180",
    x: 10.3281,
    y: 48.1973,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_di_2079_3180",
    x: 13.7705,
    y: 48.1963,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_di_2079_3180",
    x: 17.2129,
    y: 48.1963,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_di_2079_3180",
    x: 20.6553,
    y: 48.1973,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_di_2079_3180",
    x: 24.0986,
    y: 48.1973,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_di_2079_3180",
    x: 27.541,
    y: 48.1963,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_di_2079_3180",
    x: 30.9834,
    y: 48.1963,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_di_2079_3180",
    x: 34.4258,
    y: 48.1973,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_di_2079_3180",
    x: 37.8691,
    y: 51.541,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_di_2079_3180",
    x: 0,
    y: 41.3115,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_di_2079_3180",
    x: 37.8691,
    y: 41.3115,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_di_2079_3180",
    x: 0,
    y: 37.8691,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_di_2079_3180",
    x: 37.8691,
    y: 37.8691,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_di_2079_3180",
    x: 0,
    y: 34.4258,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_di_2079_3180",
    x: 37.8691,
    y: 34.4258,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_di_2079_3180",
    x: 0,
    y: 30.9834,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_di_2079_3180",
    x: 37.8691,
    y: 30.9834,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_di_2079_3180",
    x: 0,
    y: 27.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_di_2079_3180",
    x: 37.8691,
    y: 27.541,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_di_2079_3180",
    x: 0,
    y: 24.0986,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_di_2079_3180",
    x: 37.8691,
    y: 24.0986,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_di_2079_3180",
    x: 0,
    y: 20.6553,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_di_2079_3180",
    x: 37.8691,
    y: 20.6562,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_di_2079_3180",
    x: 0,
    y: 17.2129,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_di_2079_3180",
    x: 37.8691,
    y: 17.2129,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_di_2079_3180",
    x: 0,
    y: 13.7705,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_di_2079_3180",
    x: 37.8691,
    y: 13.7705,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_di_2079_3180",
    x: 0,
    y: 10.3281,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_di_2079_3180",
    x: 13.7705,
    y: 10.3281,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_di_2079_3180",
    x: 17.2129,
    y: 10.3281,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_di_2079_3180",
    x: 20.6553,
    y: 10.3281,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_di_2079_3180",
    x: 24.0986,
    y: 10.3281,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_di_2079_3180",
    x: 10.3281,
    y: 17.2129,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_di_2079_3180",
    x: 13.7705,
    y: 17.2129,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_di_2079_3180",
    x: 17.2129,
    y: 17.2129,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_di_2079_3180",
    x: 20.6553,
    y: 17.2129,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_di_2079_3180",
    x: 24.0986,
    y: 17.2129,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_di_2079_3180",
    x: 27.541,
    y: 17.2129,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_di_2079_3180",
    x: 37.8691,
    y: 10.3281,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_di_2079_3180",
    x: 0,
    y: 6.88477,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_di_2079_3180",
    x: 3.4424,
    y: 44.7539,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_di_2079_3180",
    x: 3.4424,
    y: 41.3115,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_di_2079_3180",
    x: 3.4424,
    y: 37.8691,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter60_di_2079_3180",
    x: 3.4424,
    y: 34.4258,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter61_di_2079_3180",
    x: 3.4424,
    y: 30.9834,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter62_di_2079_3180",
    x: 3.4424,
    y: 27.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter63_di_2079_3180",
    x: 3.4424,
    y: 24.0986,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter64_di_2079_3180",
    x: 3.4424,
    y: 20.6553,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter65_di_2079_3180",
    x: 3.4424,
    y: 17.2129,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter66_di_2079_3180",
    x: 3.4424,
    y: 13.7705,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter67_di_2079_3180",
    x: 3.4424,
    y: 10.3281,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter68_di_2079_3180",
    x: 3.4424,
    y: 6.88477,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter69_di_2079_3180",
    x: 37.8691,
    y: 6.88477,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter70_di_2079_3180",
    x: 34.4258,
    y: 44.7539,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter71_di_2079_3180",
    x: 34.4258,
    y: 41.3115,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter72_di_2079_3180",
    x: 34.4258,
    y: 37.8691,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter73_di_2079_3180",
    x: 34.4258,
    y: 34.4258,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter74_di_2079_3180",
    x: 34.4258,
    y: 30.9834,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter75_di_2079_3180",
    x: 34.4258,
    y: 27.541,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter76_di_2079_3180",
    x: 34.4258,
    y: 24.0986,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter77_di_2079_3180",
    x: 34.4258,
    y: 20.6562,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter78_di_2079_3180",
    x: 34.4258,
    y: 17.2129,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter79_di_2079_3180",
    x: 34.4258,
    y: 13.7705,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter80_di_2079_3180",
    x: 34.4258,
    y: 10.3281,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter81_di_2079_3180",
    x: 34.4258,
    y: 6.88477,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter82_di_2079_3180",
    x: 0,
    y: 3.44238,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter83_di_2079_3180",
    x: 37.8691,
    y: 3.44238,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter84_di_2079_3180",
    x: 0,
    y: 0,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter85_di_2079_3180",
    x: 3.4424,
    y: 0,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter86_di_2079_3180",
    x: 6.8848,
    y: 0,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter87_di_2079_3180",
    x: 10.3281,
    y: 0,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter88_di_2079_3180",
    x: 13.7705,
    y: 0,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter89_di_2079_3180",
    x: 17.2129,
    y: 0,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter90_di_2079_3180",
    x: 20.6553,
    y: 0,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter91_di_2079_3180",
    x: 24.0986,
    y: 0,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter92_di_2079_3180",
    x: 27.541,
    y: 0,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter93_di_2079_3180",
    x: 30.9834,
    y: 0,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter94_di_2079_3180",
    x: 34.4258,
    y: 0,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter95_di_2079_3180",
    x: 3.4424,
    y: 3.44238,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter96_di_2079_3180",
    x: 6.8848,
    y: 3.44238,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter97_di_2079_3180",
    x: 10.3281,
    y: 3.44238,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter98_di_2079_3180",
    x: 13.7705,
    y: 3.44238,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter99_di_2079_3180",
    x: 17.2129,
    y: 3.44238,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter100_di_2079_3180",
    x: 20.6553,
    y: 3.44238,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter101_di_2079_3180",
    x: 24.0986,
    y: 3.44238,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter102_di_2079_3180",
    x: 27.541,
    y: 3.44238,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter103_di_2079_3180",
    x: 30.9834,
    y: 3.44238,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter104_di_2079_3180",
    x: 34.4258,
    y: 3.44238,
    width: 42.459,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter105_di_2079_3180",
    x: 37.8691,
    y: 0,
    width: 42.4591,
    height: 42.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.894118 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter106_di_2079_3180",
    x: 33.2129,
    y: 49.8691,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter107_di_2079_3180",
    x: 36.6553,
    y: 49.8691,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter108_di_2079_3180",
    x: 33.2129,
    y: 39.541,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter109_di_2079_3180",
    x: 36.6553,
    y: 39.541,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter110_di_2079_3180",
    x: 29.7705,
    y: 53.3115,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter111_di_2079_3180",
    x: 40.0986,
    y: 53.3115,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter112_di_2079_3180",
    x: 29.7705,
    y: 46.4258,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter113_di_2079_3180",
    x: 33.2129,
    y: 46.4258,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter114_di_2079_3180",
    x: 36.6553,
    y: 46.4258,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter115_di_2079_3180",
    x: 40.0986,
    y: 46.4258,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter116_di_2079_3180",
    x: 29.7705,
    y: 42.9834,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter117_di_2079_3180",
    x: 33.2129,
    y: 42.9834,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter118_di_2079_3180",
    x: 36.6553,
    y: 42.9834,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter119_di_2079_3180",
    x: 40.0986,
    y: 42.9834,
    width: 10.459,
    height: 10.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2079_3180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2079_3180",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2079_3180"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnCertificate54Px);
export default __webpack_public_path__ + "static/media/earn-certificate-54px.8bed3cc7de9703c941e300d10a75c136.svg";
export { ForwardRef as ReactComponent };